var _path, _g, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _path3, _path4, _g8, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g9, _g10, _g11, _g12, _g13, _path15, _path16, _g14, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g15, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _g16, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _g17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorStand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "gridItem__media",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 1600,
    height: 1200,
    viewBox: "0 0 1600 1200",
    style: {
      enableBackground: "new 0 0 1600 1200"
    },
    xmlSpace: "preserve",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M219.81 1108.3L172.45 527.78C171.25 512.997 175.364 498.271 184.05 486.25L420.35 159.25C426.666 150.51 435.141 143.559 444.949 139.077C454.756 134.594 465.559 132.735 476.3 133.68L1285.24 205C1298.04 206.129 1310.18 211.192 1319.99 219.494C1329.81 227.796 1336.81 238.931 1340.04 251.37L1451.19 679.14C1453.91 689.642 1453.84 700.673 1450.99 711.14L1342.23 1109.73L219.81 1108.3Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M219.81 1108.3L172.45 527.78C171.25 512.997 175.364 498.271 184.05 486.25L420.35 159.25C426.666 150.51 435.141 143.559 444.949 139.077C454.756 134.594 465.559 132.735 476.3 133.68L1285.24 205C1298.04 206.129 1310.18 211.192 1319.99 219.494C1329.81 227.796 1336.81 238.931 1340.04 251.37L1451.19 679.14C1453.91 689.642 1453.84 700.673 1450.99 711.14L1342.23 1109.73L219.81 1108.3Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1184 993.92H1191V757.74C1191 756.74 1189.45 755.95 1187.53 755.95H1117.73C1115.81 755.95 1114.26 756.75 1114.26 757.74V991.56H1121.2V763.43H1184V993.92Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1184 993.92H1191V757.74C1191 756.74 1189.45 755.95 1187.53 755.95H1117.73C1115.81 755.95 1114.26 756.75 1114.26 757.74V991.56H1121.2V763.43H1184V993.92Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1095.24 1109.3H1220V1094.53H1095.24V1109.3Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1095.24 1109.3H1220V1094.53H1095.24V1109.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1179 993.92H1186V757.74C1186 756.74 1184.45 755.95 1182.53 755.95H1112.73C1110.81 755.95 1109.26 756.75 1109.26 757.74V991.56H1116.2V763.43H1179V993.92Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1179 993.92H1186V757.74C1186 756.74 1184.45 755.95 1182.53 755.95H1112.73C1110.81 755.95 1109.26 756.75 1109.26 757.74V991.56H1116.2V763.43H1179V993.92Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1125.27 904.19H1053.15V988.89H1125.27V904.19Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1125.27 904.19H1053.15V988.89H1125.27V904.19Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1067.57 930.26H1110.84V917.84H1067.57V930.26Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.97 904.19H1165.85V988.89H1237.97V904.19Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1237.97 904.19H1165.85V988.89H1237.97V904.19Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1179.96 975.71H1223.23V920.22H1179.96V975.71Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.17 1109.3H1163.28V990H1150.17V1109.3Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1150.17 1109.3H1163.28V990H1150.17V1109.3Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1142.17 1109.3H1155.28V990H1142.17V1109.3Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1142.17 1109.3H1155.28V990H1142.17V1109.3Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1088.44 1109.3H1213.2V1094.53H1088.44V1109.3Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.97 787.95H1165.85V872.64H1237.97V787.95Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1237.97 787.95H1165.85V872.64H1237.97V787.95Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1181.3 815.48H1224.57V803.06H1181.3V815.48Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.45 886.09H1279.69V871.32H1045.45V886.09Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1045.45 886.09H1279.69V871.32H1045.45V886.09Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1045.45 1003.09H1279.69V988.32H1045.45V1003.09Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1045.45 1003.09H1279.69V988.32H1045.45V1003.09Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1131.56 787.95H1059.44V872.65H1131.56V787.95Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1131.56 787.95H1059.44V872.65H1131.56V787.95Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1073.86 813.96H1117.13V801.54H1073.86V813.96Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.86 836.5H1117.13V824.08H1073.86V836.5Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.45 1003.21H1270.77L1271.13 988.44H1037.45V1003.21Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.45 886.09H1271.69V871.32H1037.45V886.09Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1088.44 1109.3H1213.2V1094.53H1088.44V1109.3Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1037.45 1003.21H1270.77L1271.13 988.44H1037.45V1003.21Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1037.45 886.09H1271.69V871.32H1037.45V886.09Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360.84 1108.44H723L723 353.98H360.84L360.84 1108.44Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M360.84 1108.44H723L723 353.98H360.84L360.84 1108.44Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360.84 1108.44H715.87L715.87 353.98H360.84L360.84 1108.44Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M360.84 1108.44H715.87L715.87 353.98H360.84L360.84 1108.44Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M697.17 1108.44V371.1H379.54L379.54 1108.44H697.17Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M697.17 1108.44V371.1H379.54L379.54 1108.44H697.17Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M697.17 1108.44V371.1H379.54L379.54 1108.44H697.17Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M606 462H477V510H606V462Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.87 708.72C440.39 704.17 423.87 718.82 407.43 714.27C403.94 713.35 401.08 708.63 401.08 705.15C401.08 701.65 403.94 700.66 407.43 701.58C423.91 706.12 440.43 691.48 456.87 696.03C460.36 696.95 463.22 701.67 463.22 705.15C463.22 708.64 460.35 709.64 456.87 708.72Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M456.87 708.72C440.39 704.17 423.87 718.82 407.43 714.27C403.94 713.35 401.08 708.63 401.08 705.15C401.08 701.65 403.94 700.66 407.43 701.58C423.91 706.12 440.43 691.48 456.87 696.03C460.36 696.95 463.22 701.67 463.22 705.15C463.22 708.64 460.35 709.64 456.87 708.72Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M382.4 1108.44L382.4 371.1H377.96L377.96 1108.44H382.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M599.86 462H470.86V510H599.86V462Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M599.86 462H470.86V510H599.86V462Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.3 953.18C341.624 952.587 340.825 952.153 339.959 951.911C339.094 951.669 338.185 951.624 337.3 951.78C325.13 954.05 310.3 968.47 309.12 974.55C307.71 981.71 303.36 980.88 300.25 985.73C297.72 989.68 300.25 996.61 301.31 999.08C301.432 999.365 301.617 999.62 301.85 999.824C302.084 1000.03 302.361 1000.18 302.66 1000.26C305.33 1001.02 312.96 1002.8 316.5 999.69C320.82 995.88 319.34 991.69 326.21 989.22C332.04 987.12 344.05 970.3 344.46 957.93C344.483 957.028 344.303 956.133 343.932 955.311C343.562 954.488 343.011 953.76 342.32 953.18",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.61 897C287.709 897.004 286.82 897.211 286.01 897.606C285.2 898.001 284.489 898.573 283.93 899.28C276.33 909.05 274.79 929.66 277.93 935.01C281.63 941.31 277.81 943.57 278.7 949.26C279.42 953.89 285.93 957.4 288.34 958.55C288.618 958.689 288.924 958.761 289.235 958.761C289.546 958.761 289.852 958.689 290.13 958.55C292.63 957.34 299.53 953.62 300.13 948.94C300.85 943.22 296.97 941.08 300.47 934.67C303.47 929.23 301.29 908.67 293.4 899.14C292.819 898.448 292.089 897.896 291.265 897.525C290.441 897.155 289.543 896.975 288.64 897",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M288.61 897C287.709 897.004 286.82 897.211 286.01 897.606C285.2 898.001 284.489 898.573 283.93 899.28C276.33 909.05 274.79 929.66 277.93 935.01C281.63 941.31 277.81 943.57 278.7 949.26C279.42 953.89 285.93 957.4 288.34 958.55C288.618 958.689 288.924 958.761 289.235 958.761C289.546 958.761 289.852 958.689 290.13 958.55C292.63 957.34 299.53 953.62 300.13 948.94C300.85 943.22 296.97 941.08 300.47 934.67C303.47 929.23 301.29 908.67 293.4 899.14C292.819 898.448 292.089 897.896 291.265 897.525C290.441 897.155 289.543 896.975 288.64 897",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M233.25 966.45C232.672 966.927 232.208 967.528 231.893 968.208C231.578 968.888 231.42 969.631 231.43 970.38C231.68 980.68 241.53 994.76 246.36 996.56C252.05 998.67 250.79 1002.14 254.36 1005.34C257.26 1007.94 263.29 1006.78 265.45 1006.25C265.701 1006.19 265.936 1006.07 266.136 1005.91C266.337 1005.75 266.499 1005.54 266.61 1005.31C267.61 1003.22 270.06 997.19 267.98 993.87C265.44 989.81 261.81 990.46 260.69 984.49C259.75 979.43 247.54 967.32 237.44 965.32C236.702 965.182 235.942 965.211 235.216 965.407C234.491 965.602 233.819 965.959 233.25 966.45",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.82 989.45C324.287 989.072 323.677 988.818 323.033 988.706C322.39 988.593 321.729 988.625 321.1 988.8C312.49 991.31 302.85 1002.8 302.42 1007.22C301.91 1012.48 298.71 1012.22 296.82 1015.91C295.28 1018.91 297.6 1023.75 298.53 1025.45C298.639 1025.65 298.79 1025.82 298.974 1025.95C299.157 1026.08 299.368 1026.17 299.59 1026.21C301.59 1026.56 307.19 1027.3 309.52 1024.81C312.37 1021.81 311 1018.81 315.77 1016.58C319.82 1014.65 327.28 1001.67 326.7 992.72C326.649 992.07 326.453 991.439 326.128 990.873C325.803 990.308 325.356 989.822 324.82 989.45",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.42 927.8C259.703 928.02 259.045 928.399 258.495 928.908C257.944 929.417 257.515 930.043 257.24 930.74C253.54 940.36 257.24 957.14 261.06 960.64C265.52 964.76 263.06 967.48 265.11 971.8C266.8 975.31 272.82 976.54 275.02 976.87C275.275 976.909 275.536 976.89 275.783 976.816C276.03 976.742 276.258 976.613 276.45 976.44C278.15 974.88 282.74 970.25 282.08 966.39C281.27 961.66 277.67 960.88 278.91 954.94C279.97 949.94 273.3 934.05 264.71 928.36C264.082 927.951 263.371 927.689 262.628 927.592C261.886 927.495 261.131 927.566 260.42 927.8",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.23 930.06C319.566 929.713 318.833 929.517 318.084 929.488C317.335 929.459 316.589 929.596 315.9 929.89C306.49 934.08 297.27 948.59 297.47 953.74C297.71 959.81 294.02 959.97 292.47 964.49C291.18 968.17 294.58 973.3 295.89 975.09C296.043 975.298 296.241 975.47 296.47 975.591C296.698 975.712 296.951 975.78 297.21 975.79C299.52 975.89 306.03 975.86 308.3 972.66C311.07 968.75 309.07 965.66 314.15 962.33C318.46 959.51 324.95 943.59 322.91 933.49C322.754 932.756 322.434 932.067 321.976 931.473C321.517 930.879 320.93 930.396 320.26 930.06",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.929 932.32C286.175 932.289 285.423 932.429 284.73 932.731C284.037 933.032 283.421 933.487 282.929 934.06C276.309 941.94 274.38 959.06 276.81 963.57C279.68 968.92 276.44 970.68 277 975.44C277.46 979.31 282.75 982.44 284.72 983.44C284.952 983.551 285.207 983.609 285.465 983.609C285.722 983.609 285.977 983.551 286.209 983.44C288.329 982.52 294.21 979.64 294.81 975.77C295.59 971.04 292.43 969.13 295.54 963.92C298.18 959.49 297.04 942.34 290.78 934.16C290.318 933.57 289.73 933.091 289.058 932.758C288.386 932.426 287.649 932.249 286.899 932.24",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.35 1009.21C258.864 1009.55 258.461 1010 258.171 1010.52C257.88 1011.04 257.709 1011.62 257.67 1012.21C257.2 1020.27 263.99 1031.92 267.67 1033.64C271.98 1035.64 270.77 1038.28 273.35 1041.02C275.45 1043.24 280.25 1042.72 281.97 1042.45C282.177 1042.42 282.375 1042.35 282.549 1042.23C282.723 1042.12 282.867 1041.96 282.97 1041.78C283.87 1040.21 286.2 1035.66 284.79 1032.93C283.06 1029.59 280.18 1029.87 279.69 1025.13C279.28 1021.13 270.53 1010.85 262.76 1008.64C262.191 1008.49 261.596 1008.47 261.017 1008.57C260.437 1008.68 259.889 1008.91 259.41 1009.25",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M324.82 989.45C324.287 989.072 323.677 988.818 323.033 988.706C322.39 988.593 321.729 988.625 321.1 988.8C312.49 991.31 302.85 1002.8 302.42 1007.22C301.91 1012.48 298.71 1012.22 296.82 1015.91C295.28 1018.91 297.6 1023.75 298.53 1025.45C298.639 1025.65 298.79 1025.82 298.974 1025.95C299.157 1026.08 299.368 1026.17 299.59 1026.21C301.59 1026.56 307.19 1027.3 309.52 1024.81C312.37 1021.81 311 1018.81 315.77 1016.58C319.82 1014.65 327.28 1001.67 326.7 992.72C326.649 992.07 326.453 991.439 326.128 990.873C325.803 990.308 325.356 989.822 324.82 989.45",
    fill: "black"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M286.929 932.32C286.175 932.289 285.423 932.429 284.73 932.731C284.037 933.032 283.421 933.487 282.929 934.06C276.309 941.94 274.38 959.06 276.81 963.57C279.68 968.92 276.44 970.68 277 975.44C277.46 979.31 282.75 982.44 284.72 983.44C284.952 983.551 285.207 983.609 285.465 983.609C285.722 983.609 285.977 983.551 286.209 983.44C288.329 982.52 294.21 979.64 294.81 975.77C295.59 971.04 292.43 969.13 295.54 963.92C298.18 959.49 297.04 942.34 290.78 934.16C290.318 933.57 289.73 933.091 289.058 932.758C288.386 932.426 287.649 932.249 286.899 932.24",
    fill: "black"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.35 1009.21C258.864 1009.55 258.461 1010 258.171 1010.52C257.88 1011.04 257.709 1011.62 257.67 1012.21C257.2 1020.27 263.99 1031.92 267.67 1033.64C271.98 1035.64 270.77 1038.28 273.35 1041.02C275.45 1043.24 280.25 1042.72 281.97 1042.45C282.177 1042.42 282.375 1042.35 282.549 1042.23C282.723 1042.12 282.867 1041.96 282.97 1041.78C283.87 1040.21 286.2 1035.66 284.79 1032.93C283.06 1029.59 280.18 1029.87 279.69 1025.13C279.28 1021.13 270.53 1010.85 262.76 1008.64C262.191 1008.49 261.596 1008.47 261.017 1008.57C260.437 1008.68 259.889 1008.91 259.41 1009.25",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M288.3 1053.6L287.7 1053.42C287.84 1052.93 302.55 1004.37 324.9 990.69L325.23 991.23C303.09 1004.79 288.45 1053.12 288.3 1053.6",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.36 1053.59C285.36 1041.15 260.27 1011.42 260.02 1011.12L260.5 1010.71C261.5 1011.94 285.93 1040.87 287.98 1053.49L287.36 1053.59Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.14 1053.54L287.51 1053.46L290.51 1027.92C292.124 1013.51 298.297 999.983 308.13 989.32L340.71 954.14L341.18 954.57L308.6 989.75C298.841 1000.31 292.71 1013.71 291.1 1028L288.14 1053.54Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.26 1053.62C287.1 1053.04 270.39 994.48 234.35 967.81L234.73 967.3C270.94 994.1 287.73 1052.86 287.87 1053.45L287.26 1053.62Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.749 935.252L286.119 935.259L287.522 1053.48L288.152 1053.47L286.749 935.252Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.201 1015.2C286.571 977.72 318.881 931.71 319.201 931.2L319.71 931.57C319.39 932.03 287.19 977.87 287.82 1015.14L287.201 1015.2Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.2 1017C286.42 1002.63 260.2 930.2 259.96 929.47L260.56 929.25C260.82 929.98 287.04 1002.51 287.83 1016.96L287.2 1017Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.437 898.572L287.808 898.596L289.075 932.342L289.704 932.318L288.437 898.572Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.753 1019.35L260.508 1019.93L270.015 1023.94L270.26 1023.36L260.753 1019.35Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.813 977.752L235.575 978.335L252.16 985.096L252.398 984.513L235.813 977.752Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.009 939.3L257.513 939.688L268.602 953.841L269.098 953.453L258.009 939.3Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.547 948.301L286.838 968.583L287.444 968.754L293.153 948.472L292.547 948.301Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.854 937.151L305.537 954.154L306.161 954.239L308.478 937.236L307.854 937.151Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.46 975.56L320.85 975.4C322.43 969.26 324.79 959.95 324.85 959.5H325.49C325.49 959.82 322.67 970.82 321.49 975.5",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.701 1004.38L305.55 1012.73L305.87 1013.28L320.021 1004.93L319.701 1004.38Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M288.299 1053.6L287.699 1053.42C287.839 1052.93 302.549 1004.37 324.899 990.69L325.229 991.23C303.089 1004.79 288.449 1053.12 288.299 1053.6",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.36 1053.59C285.36 1041.15 260.27 1011.42 260.02 1011.12L260.5 1010.71C261.5 1011.94 285.93 1040.87 287.98 1053.49L287.36 1053.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M288.14 1053.54L287.51 1053.46L290.51 1027.92C292.124 1013.51 298.297 999.983 308.13 989.32L340.71 954.14L341.18 954.57L308.6 989.75C298.841 1000.31 292.71 1013.71 291.1 1028L288.14 1053.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.26 1053.62C287.1 1053.04 270.39 994.48 234.35 967.81L234.73 967.3C270.94 994.1 287.73 1052.86 287.87 1053.45L287.26 1053.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M286.749 935.252L286.119 935.259L287.522 1053.48L288.152 1053.47L286.749 935.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.2 1015.2C286.57 977.72 318.88 931.71 319.2 931.2L319.71 931.57C319.39 932.03 287.19 977.87 287.82 1015.14L287.2 1015.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.2 1017C286.42 1002.63 260.2 930.2 259.96 929.47L260.56 929.25C260.82 929.98 287.04 1002.51 287.83 1016.96L287.2 1017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M288.436 898.572L287.807 898.596L289.074 932.342L289.703 932.318L288.436 898.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260.753 1019.35L260.508 1019.93L270.015 1023.94L270.26 1023.36L260.753 1019.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M235.813 977.752L235.575 978.335L252.16 985.096L252.398 984.513L235.813 977.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M258.009 939.3L257.513 939.688L268.602 953.841L269.098 953.453L258.009 939.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M292.547 948.301L286.838 968.583L287.444 968.754L293.153 948.472L292.547 948.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M307.853 937.151L305.536 954.154L306.16 954.239L308.477 937.236L307.853 937.151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M321.46 975.56L320.85 975.4C322.43 969.26 324.79 959.95 324.85 959.5H325.49C325.49 959.82 322.67 970.82 321.49 975.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M319.7 1004.38L305.549 1012.73L305.869 1013.28L320.02 1004.93L319.7 1004.38Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.5 1108.15H276.5C274.892 1108.15 273.301 1107.83 271.816 1107.22C270.331 1106.6 268.981 1105.7 267.845 1104.56C266.708 1103.43 265.807 1102.08 265.191 1100.59C264.576 1099.11 264.26 1097.52 264.26 1095.91V1054.28H311.79V1095.91C311.79 1097.52 311.473 1099.11 310.857 1100.6C310.241 1102.08 309.339 1103.43 308.201 1104.57C307.064 1105.71 305.713 1106.61 304.227 1107.22C302.741 1107.84 301.148 1108.15 299.54 1108.15",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M288.3 1108.15H299.5C301.108 1108.15 302.701 1107.84 304.187 1107.22C305.673 1106.61 307.024 1105.71 308.161 1104.57C309.299 1103.43 310.201 1102.08 310.817 1100.6C311.433 1099.11 311.75 1097.52 311.75 1095.91V1059.39L264.34 1059.99L264.22 1061.99H299.07V1096.73C299.07 1096.73 301.61 1108.13 288.3 1108.13",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.89 1060H262.44C262.07 1060 261.717 1059.85 261.456 1059.59C261.196 1059.32 261.05 1058.97 261.05 1058.6V1055.69C261.05 1055.32 261.196 1054.97 261.456 1054.7C261.717 1054.44 262.07 1054.29 262.44 1054.29H312.89C313.259 1054.29 313.613 1054.44 313.873 1054.7C314.134 1054.97 314.28 1055.32 314.28 1055.69V1058.6C314.28 1058.97 314.134 1059.32 313.873 1059.59C313.613 1059.85 313.259 1060 312.89 1060Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M314.28 1058.59V1055.68C314.274 1055.49 314.23 1055.3 314.151 1055.13C314.072 1054.96 313.96 1054.8 313.82 1054.67C313.681 1054.54 313.518 1054.44 313.339 1054.37C313.161 1054.3 312.971 1054.27 312.78 1054.28H302.78V1060H312.78C312.971 1060.01 313.161 1059.98 313.339 1059.91C313.518 1059.84 313.681 1059.74 313.82 1059.61C313.96 1059.48 314.072 1059.32 314.151 1059.15C314.23 1058.98 314.274 1058.79 314.28 1058.6",
    fill: "black"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1025.34 435.3H970.93V486.23H1025.34V435.3Z",
    fill: "black"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M1314.69 358.03H892.04V638.31H1314.69V358.03Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321 358.03H1314.69V638.31H1321V358.03Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.13 369.14H904.12V628.34H1304.13V369.14Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1304.13 369.14H904.12V628.34H1304.13V369.14Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M911.85 369.14H904.12V628.34H911.85V369.14Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1321 358.03H1314.69V638.31H1321V358.03Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M911.85 369.14H904.12V628.34H911.85V369.14Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M928.93 521.64H1126.16V384.94H928.93V521.64Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1051.99 464.47H1114.09V395.34H1051.99V464.47Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1051.99 464.47H1114.09V395.34H1051.99V464.47Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M939.4 401.08H1045.57V395.34H939.4V401.08Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.4 413.07H1045.57V407.33H939.4V413.07Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.2 425.06H1045.57V419.32H957.2V425.06Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.4 437.04H1045.57V431.3H939.4V437.04Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.4 460.99H1045.57V455.25H939.4V460.99Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.68 480.31H1114.09V474.87H1044.68V480.31Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.68 491.93H1114.09V486.49H1044.68V491.93Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.68 503.69H1114.09V498.25H1044.68V503.69Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.4 449.04H993.32V443.3H939.4V449.04Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.23 449.04H1045.57V443.3H1000.23V449.04Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.13 474.87H939.41V513.83H1030.13V474.87Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1030.13 474.87H939.41V513.83H1030.13V474.87Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M939.4 401.08H1045.57V395.34H939.4V401.08Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M939.4 413.07H1045.57V407.33H939.4V413.07Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M957.2 425.06H1045.57V419.32H957.2V425.06Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M939.4 437.04H1045.57V431.3H939.4V437.04Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M939.4 460.99H1045.57V455.25H939.4V460.99Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1044.68 480.31H1114.09V474.87H1044.68V480.31Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1044.68 491.93H1114.09V486.49H1044.68V491.93Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1044.68 503.69H1114.09V498.25H1044.68V503.69Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M939.4 449.04H993.32V443.3H939.4V449.04Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1000.23 449.04H1045.57V443.3H1000.23V449.04Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.66 424.47C1070.94 423.84 1072.15 423.19 1073.41 422.65C1074.71 422.069 1076.1 421.747 1077.52 421.7C1078.8 421.628 1080.07 421.95 1081.16 422.622C1082.25 423.294 1083.1 424.285 1083.61 425.46C1084.7 427.715 1085.26 430.194 1085.23 432.7C1085.29 436.55 1085.12 440.4 1085.06 444.24C1085.06 447.65 1084.96 451.06 1086.12 454.34C1086.35 455.193 1086.79 455.973 1087.41 456.604C1088.02 457.234 1088.79 457.695 1089.64 457.94C1090.15 458.072 1090.68 458.139 1091.21 458.14C1097.38 458.14 1103.56 458.14 1109.74 458.14C1110.02 458.175 1110.3 458.145 1110.57 458.051C1110.83 457.957 1111.07 457.802 1111.27 457.599C1111.46 457.396 1111.6 457.15 1111.69 456.881C1111.77 456.612 1111.79 456.327 1111.74 456.05C1111.72 452.029 1111.13 448.031 1110.01 444.17C1109.25 441.371 1107.64 438.88 1105.39 437.05C1104.39 436.309 1103.29 435.723 1102.12 435.31C1099.69 434.64 1097.32 433.801 1095.01 432.8C1093.67 432.201 1092.51 431.272 1091.63 430.1C1091.3 429.593 1091.09 429.022 1091 428.425C1090.92 427.828 1090.96 427.219 1091.13 426.64C1091.19 426.482 1091.28 426.341 1091.41 426.23C1094.23 423.213 1095.83 419.258 1095.9 415.13C1096.01 413.459 1095.92 411.781 1095.64 410.13C1095.35 408.832 1094.77 407.614 1093.96 406.564C1093.14 405.514 1092.1 404.659 1090.91 404.06C1088.81 402.811 1086.48 402.018 1084.05 401.736C1081.63 401.453 1079.17 401.686 1076.84 402.42C1075.74 402.681 1074.72 403.209 1073.88 403.958C1073.03 404.706 1072.38 405.651 1071.99 406.71C1071.75 407.517 1071.64 408.358 1071.67 409.2C1071.8 411.419 1071.06 413.601 1069.6 415.28C1068.74 416.28 1067.98 417.28 1067.19 418.28C1066.94 418.578 1066.74 418.916 1066.6 419.28C1066.47 419.641 1066.43 420.027 1066.47 420.408C1066.52 420.788 1066.65 421.154 1066.86 421.475C1067.07 421.796 1067.35 422.065 1067.68 422.26C1068.01 422.455 1068.38 422.572 1068.76 422.6C1069.38 422.68 1069.62 422.86 1069.57 423.47C1069.57 423.805 1069.6 424.14 1069.66 424.47V424.47Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.1 458.15C1082.77 456.041 1081.97 453.638 1081.79 451.15C1081.6 448.982 1081.52 446.806 1081.55 444.63C1081.55 441.73 1081.84 438.84 1081.79 435.94C1081.71 433.687 1081.51 431.44 1081.17 429.21C1081.03 428.419 1080.76 427.656 1080.38 426.95C1080.12 426.362 1079.68 425.877 1079.11 425.575C1078.54 425.272 1077.89 425.168 1077.26 425.28C1075.75 425.498 1074.29 426.001 1072.97 426.76C1072.24 427.13 1071.54 427.57 1070.78 428C1071.23 428.72 1071.82 429.34 1072.52 429.823C1073.22 430.306 1074.01 430.642 1074.84 430.81C1074.9 431.485 1074.75 432.161 1074.4 432.743C1074.05 433.325 1073.53 433.783 1072.91 434.05C1071.55 434.587 1070.1 434.842 1068.64 434.8C1067.03 434.799 1065.43 435.158 1063.97 435.85C1062.52 436.541 1061.23 437.549 1060.21 438.8C1058.84 440.545 1057.82 442.543 1057.21 444.68C1056.24 448.033 1055.65 451.485 1055.45 454.97C1055.45 455.32 1055.39 455.68 1055.37 456.04C1055.32 456.312 1055.33 456.593 1055.4 456.86C1055.48 457.127 1055.61 457.373 1055.8 457.579C1055.99 457.785 1056.22 457.944 1056.48 458.045C1056.74 458.146 1057.01 458.185 1057.29 458.16C1059.13 458.16 1060.97 458.16 1062.81 458.16H1084.12L1084.1 458.15Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M971.2 509.46C972.159 509.313 973.139 509.377 974.07 509.65C977.78 510.56 981.6 509.91 985.23 508.97C989.57 507.49 993.75 509.97 998.14 509.73C1001.71 509.84 1005.02 507.38 1004.84 503.62C1004.81 501.567 1004.36 499.543 1003.52 497.67C1000.52 490.28 1003.02 484.26 1004.28 476.97H987.35C987.705 481.497 987.805 486.041 987.65 490.58C987.5 493.99 980.23 496.08 977.7 498.08C976.214 499.268 974.428 500.022 972.54 500.26C971.122 500.471 969.761 500.967 968.54 501.72C968.347 501.811 968.128 501.832 967.92 501.78C967.408 501.681 966.881 501.685 966.371 501.794C965.86 501.902 965.377 502.111 964.949 502.41C964.521 502.708 964.157 503.089 963.879 503.531C963.601 503.972 963.414 504.465 963.33 504.98C962.69 509.36 967.79 510.62 971.2 509.46ZM993.44 497.2C995.32 499.1 996.67 495.68 998.19 497.2C999.82 500.2 993.41 501.33 991.74 499.2C991.587 499.096 991.458 498.96 991.36 498.803C991.263 498.645 991.2 498.469 991.175 498.286C991.15 498.102 991.164 497.915 991.216 497.737C991.268 497.56 991.357 497.395 991.477 497.254C991.597 497.113 991.745 496.998 991.912 496.918C992.079 496.838 992.261 496.794 992.447 496.789C992.632 496.784 992.816 496.818 992.987 496.889C993.158 496.96 993.313 497.066 993.44 497.2V497.2Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.17 595.61H1287.8V436.69H1158.17V595.61Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1184.49 516.16H1263.64V447.14H1184.49V516.16Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1184.49 516.16H1263.64V447.14H1184.49V516.16Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1200.62 486.41L1199.79 486.84C1199.31 487.063 1198.9 487.401 1198.59 487.823C1198.27 488.245 1198.07 488.738 1197.99 489.258C1197.92 489.778 1197.97 490.309 1198.15 490.803C1198.33 491.297 1198.63 491.74 1199.02 492.09C1199.23 492.259 1199.39 492.478 1199.48 492.728C1199.57 492.977 1199.6 493.247 1199.56 493.51C1199.52 494.611 1199.56 495.715 1199.68 496.81C1199.71 496.891 1199.76 496.962 1199.82 497.018C1199.89 497.074 1199.97 497.113 1200.05 497.13C1201.61 497.05 1203.18 496.94 1204.71 496.84C1204.88 495.51 1205.3 494.95 1206.18 494.78C1206.59 494.721 1207.01 494.8 1207.37 495.004C1207.73 495.208 1208.02 495.527 1208.18 495.91L1208.85 495.68L1209.58 495.41C1209.51 495.201 1209.49 494.98 1209.51 494.761C1209.53 494.542 1209.59 494.329 1209.69 494.134C1209.79 493.939 1209.93 493.765 1210.1 493.624C1210.27 493.483 1210.46 493.376 1210.67 493.31C1211.03 493.193 1211.42 493.196 1211.78 493.319C1212.14 493.441 1212.45 493.677 1212.67 493.99C1213.24 493.88 1213.39 493.53 1213.35 492.99C1213.31 492.45 1213.35 491.7 1213.35 491.09C1212.35 490.99 1211.42 490.94 1210.49 490.8C1210.26 490.782 1210.04 490.715 1209.83 490.604C1209.63 490.494 1209.45 490.341 1209.31 490.158C1209.17 489.974 1209.08 489.763 1209.02 489.538C1208.97 489.313 1208.97 489.08 1209.01 488.853C1209.05 488.627 1209.15 488.412 1209.28 488.223C1209.41 488.034 1209.58 487.875 1209.78 487.757C1209.98 487.639 1210.2 487.564 1210.43 487.536C1210.66 487.509 1210.89 487.531 1211.11 487.6C1212.44 487.782 1213.8 487.721 1215.11 487.42C1216.92 487.12 1218.73 486.72 1220.55 486.6C1221.98 486.416 1223.43 486.695 1224.69 487.397C1225.95 488.099 1226.95 489.186 1227.55 490.5C1228.91 493.24 1231.49 494.5 1234.74 493.86C1238.62 493.272 1242.27 491.671 1245.33 489.22C1249.96 485.35 1251.96 480.47 1251.15 474.57C1250.79 471.52 1249.82 468.573 1248.31 465.9C1246.47 462.713 1243.71 460.155 1240.39 458.56C1236.61 456.76 1232.5 455.739 1228.31 455.56C1223.66 455.191 1218.98 455.528 1214.43 456.56C1210.03 457.431 1205.97 459.548 1202.74 462.66C1200.23 465.17 1198.76 468.533 1198.62 472.08C1198.51 474.232 1198.79 476.386 1199.44 478.44C1199.5 478.561 1199.53 478.693 1199.54 478.827C1199.54 478.961 1199.52 479.095 1199.48 479.221C1199.43 479.347 1199.36 479.463 1199.27 479.56C1199.17 479.658 1199.06 479.736 1198.94 479.79C1198.61 479.997 1198.28 480.197 1197.94 480.39C1197.7 480.488 1197.49 480.643 1197.33 480.842C1197.17 481.04 1197.05 481.275 1197 481.527C1196.95 481.779 1196.96 482.039 1197.04 482.285C1197.11 482.532 1197.24 482.757 1197.42 482.94C1198.27 483.99 1199.21 484.94 1200.13 485.99C1200.28 486.142 1200.45 486.282 1200.62 486.41ZM1205.06 476.62C1205.5 476.375 1206 476.259 1206.5 476.285C1207 476.312 1207.49 476.48 1207.9 476.77C1208.59 477.182 1209.21 477.694 1209.74 478.29C1210.38 478.917 1210.88 479.67 1211.21 480.502C1211.54 481.334 1211.69 482.226 1211.66 483.12C1211.64 483.546 1211.51 483.959 1211.28 484.32C1211.05 484.682 1210.74 484.979 1210.37 485.186C1209.99 485.392 1209.57 485.499 1209.15 485.498C1208.72 485.497 1208.3 485.388 1207.93 485.18C1206.83 484.671 1205.87 483.895 1205.15 482.922C1204.42 481.949 1203.95 480.811 1203.78 479.61C1203.75 478 1204.16 477.1 1205.06 476.62Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.77 500L1200.32 500.51C1200.38 501.3 1200.44 502.12 1200.5 502.94C1200.56 503.727 1200.79 504.491 1201.18 505.176C1201.57 505.861 1202.11 506.45 1202.76 506.901C1203.41 507.351 1204.15 507.651 1204.93 507.779C1205.71 507.907 1206.5 507.859 1207.26 507.64C1210.14 506.9 1212.98 506.01 1215.84 505.21C1217.23 504.82 1218.65 504.51 1220.04 504.11C1221.18 503.836 1222.19 503.201 1222.94 502.299C1223.68 501.397 1224.12 500.278 1224.17 499.11C1224.34 497.29 1224.65 495.48 1224.83 493.66C1224.86 493.18 1224.76 492.7 1224.55 492.27C1224.25 491.442 1223.65 490.751 1222.88 490.322C1222.11 489.893 1221.21 489.754 1220.35 489.93C1219.35 490.02 1218.29 490.23 1217.26 490.36C1216.86 490.36 1216.78 490.6 1216.79 490.95C1216.79 492.07 1216.79 493.2 1216.79 494.32C1216.82 494.685 1216.74 495.051 1216.56 495.371C1216.38 495.691 1216.12 495.952 1215.79 496.12C1215.22 496.43 1214.67 496.76 1214.11 497.07C1214.28 498.29 1214.11 498.87 1213.28 499.25C1212.94 499.441 1212.54 499.502 1212.16 499.423C1211.78 499.344 1211.44 499.13 1211.2 498.82C1211.17 498.755 1211.12 498.699 1211.06 498.653C1211 498.608 1210.93 498.575 1210.86 498.556C1210.79 498.537 1210.72 498.533 1210.65 498.544C1210.57 498.555 1210.5 498.581 1210.44 498.62C1210.05 498.78 1209.64 498.9 1209.16 499.07C1209.29 499.39 1209.32 499.739 1209.25 500.076C1209.18 500.413 1209.02 500.724 1208.78 500.97C1208.52 501.193 1208.21 501.351 1207.88 501.43C1206.9 501.61 1206.33 501.19 1205.77 500Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1170.57 533.77H1275.41V527.92H1170.57V533.77Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.57 545.88H1275.41V540.03H1170.57V545.88Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.57 557.98H1275.41V552.13H1170.57V557.98Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.57 570.08H1275.41V564.23H1170.57V570.08Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.57 582.19H1275.41V576.34H1170.57V582.19Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1170.57 533.77H1275.41V527.92H1170.57V533.77Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1170.57 545.88H1275.41V540.03H1170.57V545.88Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1170.57 557.98H1275.41V552.13H1170.57V557.98Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1170.57 570.08H1275.41V564.23H1170.57V570.08Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1170.57 582.19H1275.41V576.34H1170.57V582.19Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.28 537.56H963.65V616.19H1042.28V537.56Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1008.65 552.42H997.289V601.35H1008.65V552.42Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.43 582.56V571.2H978.5V582.56H1027.43Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1008.65 552.42H997.289V601.35H1008.65V552.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1027.43 582.56V571.2H978.5V582.56H1027.43Z",
    fill: "white"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M655 1095.13L709.65 1096.52L687.8 1081C686.03 1079.75 684.577 1078.11 683.561 1076.2C682.545 1074.29 681.993 1072.16 681.95 1070L680.95 1052.67L651.28 1052.77L655 1095.13Z",
    fill: "#FC9D9D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M661 1075.14V1074.82C660.896 1073.92 661.152 1073.01 661.714 1072.29C662.276 1071.58 663.098 1071.11 664 1071L681.76 1068.44L681.55 1065.04H652.07L654.73 1093.96L678.55 1091.31L670.68 1088.22C668.034 1087.12 665.736 1085.32 664.031 1083.02C662.326 1080.72 661.279 1077.99 661 1075.14V1075.14Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M556.59 1093.18H581.15L585.72 1051.61L556.72 1051.71L556.59 1093.18Z",
    fill: "#FC9D9D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M562.76 1086.16L563.39 1073.4C563.453 1072.6 563.783 1071.84 564.326 1071.24C564.869 1070.65 565.595 1070.25 566.39 1070.11L584.04 1067.45L584.47 1063.94L556.82 1064.05L556.72 1093.5L562.76 1086.16Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M729.27 1104.17V1103C729.27 1101.14 728.532 1099.36 727.219 1098.05C725.907 1096.74 724.126 1096 722.27 1096H712.49C710.424 1096.02 708.435 1095.22 706.96 1093.77L682 1070L674.24 1080.21C673.632 1081.01 672.852 1081.65 671.959 1082.11C671.066 1082.56 670.082 1082.81 669.08 1082.83C668.079 1082.85 667.086 1082.64 666.175 1082.22C665.264 1081.81 664.459 1081.19 663.82 1080.42C663.192 1079.67 662.412 1079.07 661.533 1078.65C660.654 1078.22 659.695 1077.99 658.72 1077.97H653.51V1103.71L729.27 1104.17Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.27 1104.17V1108H653.27V1103.75L729.27 1104.17Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677 1076.42L693.9 1090.14C694.804 1090.87 695.943 1091.23 697.101 1091.17C698.258 1091.12 699.354 1090.63 700.18 1089.82L701.45 1088.54L682 1070C681.493 1069.86 680.954 1069.88 680.459 1070.06C679.964 1070.24 679.538 1070.57 679.24 1071L677.24 1073.87C676.98 1074.19 676.813 1074.58 676.757 1075C676.7 1075.41 676.757 1075.83 676.92 1076.21L677 1076.42Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 1074.36H580C580.92 1074.35 581.811 1074.68 582.5 1075.29C583.188 1075.9 583.623 1076.75 583.72 1077.66L584.15 1085.31C584.271 1087.68 584.888 1090 585.96 1092.12L586.7 1093.5C588.045 1096.17 588.731 1099.12 588.7 1102.11V1103.5H549.78C549.792 1099.7 550.942 1096 553.08 1092.86C554.686 1090.52 555.689 1087.82 556 1085L556.85 1077.35C557.03 1076.5 557.498 1075.73 558.176 1075.19C558.854 1074.64 559.7 1074.35 560.57 1074.35H561.96",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 1103.39H588.81V1107.11H550V1103.39Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.86 1070.85H567.12C566.434 1070.85 565.756 1070.99 565.13 1071.27C564.505 1071.55 563.947 1071.96 563.493 1072.48C563.039 1072.99 562.701 1073.6 562.5 1074.25C562.3 1074.91 562.242 1075.6 562.33 1076.28L563.61 1086.7C563.819 1088.25 564.579 1089.67 565.751 1090.7C566.923 1091.74 568.428 1092.32 569.99 1092.33C571.578 1092.34 573.114 1091.76 574.294 1090.7C575.475 1089.64 576.215 1088.17 576.37 1086.59L577.54 1076.17C577.637 1075.5 577.588 1074.82 577.397 1074.18C577.205 1073.53 576.875 1072.93 576.43 1072.43C575.985 1071.92 575.435 1071.52 574.819 1071.25C574.202 1070.97 573.534 1070.84 572.86 1070.85Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M729.27 1104.17V1108H653.27V1103.75L729.27 1104.17Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M677 1076.42L693.9 1090.14C694.804 1090.87 695.943 1091.23 697.101 1091.17C698.258 1091.12 699.354 1090.63 700.18 1089.82L701.45 1088.54L682 1070C681.493 1069.86 680.954 1069.88 680.459 1070.06C679.964 1070.24 679.538 1070.57 679.24 1071L677.24 1073.87C676.98 1074.19 676.813 1074.58 676.757 1075C676.7 1075.41 676.757 1075.83 676.92 1076.21L677 1076.42Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M550 1103.39H588.81V1107.11H550V1103.39Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M572.86 1070.85H567.12C566.434 1070.85 565.756 1070.99 565.13 1071.27C564.505 1071.55 563.947 1071.96 563.493 1072.48C563.039 1072.99 562.701 1073.6 562.5 1074.25C562.3 1074.91 562.242 1075.6 562.33 1076.28L563.61 1086.7C563.819 1088.25 564.579 1089.67 565.751 1090.7C566.923 1091.74 568.428 1092.32 569.99 1092.33C571.578 1092.34 573.114 1091.76 574.294 1090.7C575.475 1089.64 576.215 1088.17 576.37 1086.59L577.54 1076.17C577.637 1075.5 577.588 1074.82 577.397 1074.18C577.205 1073.53 576.875 1072.93 576.43 1072.43C575.985 1071.92 575.435 1071.52 574.819 1071.25C574.202 1070.97 573.534 1070.84 572.86 1070.85Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M580.3 1078.46H559.67C559.484 1078.46 559.306 1078.39 559.175 1078.26C559.044 1078.12 558.97 1077.95 558.97 1077.76C558.97 1077.57 559.044 1077.4 559.175 1077.27C559.306 1077.13 559.484 1077.06 559.67 1077.06H580.3C580.485 1077.06 580.663 1077.13 580.795 1077.27C580.926 1077.4 581 1077.57 581 1077.76C581 1077.95 580.926 1078.12 580.795 1078.26C580.663 1078.39 580.485 1078.46 580.3 1078.46Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M579.66 1083.35H560.31C560.212 1083.36 560.112 1083.35 560.018 1083.32C559.923 1083.29 559.836 1083.24 559.762 1083.18C559.688 1083.11 559.629 1083.03 559.588 1082.94C559.547 1082.85 559.526 1082.75 559.526 1082.66C559.526 1082.56 559.547 1082.46 559.588 1082.37C559.629 1082.28 559.688 1082.2 559.762 1082.13C559.836 1082.07 559.923 1082.02 560.018 1081.99C560.112 1081.96 560.212 1081.95 560.31 1081.96H579.66C579.758 1081.95 579.858 1081.96 579.952 1081.99C580.047 1082.02 580.134 1082.07 580.208 1082.13C580.282 1082.2 580.341 1082.28 580.382 1082.37C580.422 1082.46 580.443 1082.56 580.443 1082.66C580.443 1082.75 580.422 1082.85 580.382 1082.94C580.341 1083.03 580.282 1083.11 580.208 1083.18C580.134 1083.24 580.047 1083.29 579.952 1083.32C579.858 1083.35 579.758 1083.36 579.66 1083.35V1083.35Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M579.13 1088.14H560.84C560.654 1088.14 560.476 1088.07 560.345 1087.93C560.213 1087.8 560.14 1087.63 560.14 1087.44C560.14 1087.25 560.213 1087.08 560.345 1086.95C560.476 1086.81 560.654 1086.74 560.84 1086.74H579.13C579.315 1086.74 579.493 1086.81 579.625 1086.95C579.756 1087.08 579.83 1087.25 579.83 1087.44C579.83 1087.63 579.756 1087.8 579.625 1087.93C579.493 1088.07 579.315 1088.14 579.13 1088.14Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M688.76 1089.13C688.664 1089.13 688.569 1089.11 688.481 1089.07C688.393 1089.04 688.314 1088.98 688.25 1088.91C688.182 1088.85 688.128 1088.77 688.091 1088.68C688.054 1088.6 688.035 1088.5 688.035 1088.41C688.035 1088.32 688.054 1088.22 688.091 1088.14C688.128 1088.05 688.182 1087.97 688.25 1087.91L695.8 1080.78C695.865 1080.71 695.943 1080.66 696.029 1080.63C696.115 1080.59 696.207 1080.57 696.3 1080.57C696.392 1080.57 696.484 1080.59 696.57 1080.63C696.656 1080.66 696.734 1080.71 696.8 1080.78C696.865 1080.85 696.917 1080.92 696.953 1081.01C696.988 1081.1 697.007 1081.19 697.007 1081.28C697.007 1081.37 696.988 1081.46 696.953 1081.55C696.917 1081.64 696.865 1081.71 696.8 1081.78L689.25 1088.9C689.187 1088.97 689.112 1089.02 689.028 1089.06C688.944 1089.1 688.852 1089.13 688.76 1089.13V1089.13Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M684.51 1085.62C684.37 1085.62 684.231 1085.58 684.114 1085.51C683.997 1085.43 683.906 1085.32 683.854 1085.19C683.802 1085.06 683.791 1084.91 683.822 1084.78C683.854 1084.64 683.926 1084.51 684.03 1084.42L691.79 1077.08C691.923 1076.95 692.103 1076.87 692.29 1076.87C692.478 1076.87 692.657 1076.95 692.79 1077.08C692.923 1077.21 692.997 1077.39 692.997 1077.58C692.997 1077.77 692.923 1077.95 692.79 1078.08L685.03 1085.41C684.963 1085.48 684.882 1085.53 684.792 1085.57C684.703 1085.61 684.607 1085.62 684.51 1085.62V1085.62Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M680.46 1082C680.366 1082 680.273 1081.98 680.186 1081.94C680.1 1081.91 680.023 1081.85 679.96 1081.78C679.894 1081.71 679.841 1081.64 679.805 1081.55C679.769 1081.47 679.75 1081.37 679.75 1081.28C679.75 1081.19 679.769 1081.09 679.805 1081.01C679.841 1080.92 679.894 1080.85 679.96 1080.78L687.62 1073.55C687.686 1073.48 687.764 1073.43 687.85 1073.4C687.935 1073.36 688.027 1073.34 688.12 1073.34C688.213 1073.34 688.305 1073.36 688.391 1073.4C688.477 1073.43 688.554 1073.48 688.62 1073.55C688.686 1073.62 688.738 1073.69 688.773 1073.78C688.809 1073.87 688.827 1073.96 688.827 1074.05C688.827 1074.14 688.809 1074.23 688.773 1074.32C688.738 1074.41 688.686 1074.48 688.62 1074.55L680.97 1081.78C680.905 1081.85 680.826 1081.9 680.738 1081.94C680.65 1081.98 680.556 1082 680.46 1082Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M672 726.82L683 1064.51H651.05L621.54 787.62C621.451 786.764 621.051 785.971 620.414 785.391C619.778 784.812 618.95 784.488 618.09 784.48C617.207 784.448 616.346 784.756 615.684 785.34C615.022 785.924 614.609 786.74 614.53 787.62L586.8 1064.51H554.88V724.93L672 726.82Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.15 1057.61H588.68L588.06 1064.51H554.06L554.15 1057.61Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M554.15 1057.61H568.59L568.28 1064.51H554.05L554.15 1057.61Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M650.84 1063L621.54 787.67C621.451 786.814 621.051 786.021 620.414 785.441C619.778 784.862 618.95 784.538 618.09 784.53H622.09C626.166 784.565 630.089 786.081 633.131 788.794C636.172 791.508 638.123 795.235 638.62 799.28L669.62 1060.8L650.84 1063Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M649.48 1057.61H683.6L684.021 1064.51H650.22L649.48 1057.61Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M649.48 1057.61H669.16L670.1 1064.51H650.22L649.48 1057.61Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M581.25 727.45L568.59 1057.45L554.88 1057.35V727.35L581.25 727.45Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M640.27 595.17L560.12 617.46L552.58 680.35L552.22 807.42H616.31L619.32 782.77L621.88 807.42H677.21L674.82 667.74L640.27 595.17Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M674.6 654.51L674.82 667.74L678.89 676.27L674.6 654.51Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M683.18 648.23L578.43 628.35L577.7 607.83L579.26 649.9H587.53V678.26L556.87 682.13C554.34 682.456 551.77 682.272 549.313 681.589C546.855 680.906 544.559 679.738 542.56 678.153C540.561 676.569 538.899 674.6 537.673 672.364C536.446 670.127 535.68 667.667 535.42 665.13L527.88 588.53C527.33 583.051 528.699 577.551 531.754 572.969C534.809 568.388 539.36 565.009 544.63 563.41C583.45 551.59 586.07 551.8 586.07 551.8L628.07 551.59L669.07 558.91C673.095 559.523 676.864 561.267 679.937 563.938C683.011 566.61 685.262 570.099 686.43 574L711 658C715.29 672.24 702.31 685.94 687.87 682.28L683.71 681L683.18 648.23Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M596.34 612.35C594.806 605.574 593.615 598.726 592.77 591.83L594.33 591.62C595.168 598.468 596.35 605.27 597.87 612L596.34 612.35Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M590.9 612.37C591 613.549 591.446 614.673 592.183 615.599C592.919 616.525 593.913 617.213 595.04 617.576C596.166 617.939 597.374 617.96 598.513 617.638C599.652 617.316 600.67 616.664 601.439 615.764C602.208 614.865 602.694 613.758 602.836 612.583C602.977 611.408 602.769 610.218 602.235 609.161C601.702 608.105 600.868 607.23 599.839 606.646C598.81 606.062 597.631 605.796 596.45 605.88C595.658 605.937 594.885 606.15 594.175 606.508C593.466 606.866 592.835 607.361 592.319 607.965C591.803 608.569 591.411 609.269 591.168 610.025C590.924 610.781 590.833 611.578 590.9 612.37Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M593.3 612.18C593.354 612.899 593.62 613.585 594.065 614.153C594.509 614.72 595.112 615.143 595.796 615.367C596.481 615.592 597.217 615.608 597.911 615.414C598.605 615.22 599.226 614.824 599.695 614.276C600.164 613.729 600.46 613.055 600.545 612.339C600.63 611.623 600.501 610.898 600.174 610.256C599.847 609.614 599.336 609.083 598.707 608.732C598.078 608.38 597.359 608.223 596.64 608.28C595.682 608.359 594.794 608.813 594.169 609.543C593.543 610.274 593.231 611.221 593.3 612.18V612.18Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M614.88 612.16C614.88 612.16 623.32 689.91 619.32 784.55",
    stroke: "black",
    strokeWidth: 0.89,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M586.44 551.74L581.09 552.92L614.88 610.38L631.69 552.29L621.1 549.96",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M574.14 625.31C575.39 625.52 579.58 625.52 581.04 626.67L583.35 628.34L588.16 629.29L586.9 650.11L571.31 651.89L569.64 625L574.14 625.31Z",
    fill: "#FC9D9D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M655.34 642.79L654.82 598.79C654.822 598.597 654.893 598.412 655.021 598.267C655.148 598.123 655.323 598.029 655.514 598.004C655.705 597.978 655.899 598.023 656.06 598.128C656.221 598.234 656.338 598.395 656.39 598.58L669.78 645.68L655.34 642.79Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M627.09 502.66C627.09 502.66 590.36 479.66 589.09 507.79L588.57 515.12L586.07 552C586.091 552.668 586.278 553.319 586.616 553.896C586.953 554.472 587.429 554.955 588 555.3L608.15 569C608.464 569.178 608.825 569.253 609.184 569.216C609.543 569.178 609.88 569.029 610.15 568.79L625.84 555.29C626.381 554.859 626.8 554.295 627.058 553.654C627.315 553.012 627.402 552.315 627.31 551.63L624.9 529.76C625.38 527.596 625.624 525.387 625.63 523.17C626 512.4 627.09 502.66 627.09 502.66Z",
    fill: "#FC9D9D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M642.68 491.78C642.682 489.315 641.952 486.904 640.584 484.854C639.216 482.803 637.27 481.205 634.993 480.26C632.715 479.316 630.209 479.069 627.791 479.549C625.373 480.029 623.152 481.216 621.409 482.96C619.666 484.703 618.479 486.924 617.999 489.342C617.518 491.76 617.766 494.266 618.71 496.543C619.654 498.82 621.253 500.766 623.304 502.134C625.354 503.503 627.765 504.232 630.23 504.23C631.866 504.235 633.488 503.917 635 503.293C636.513 502.669 637.888 501.752 639.045 500.595C640.202 499.438 641.119 498.064 641.743 496.551C642.367 495.038 642.685 493.417 642.68 491.78V491.78Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M631.17 482.68C631.17 482.68 644.17 537.3 616.17 540.97C591.89 544.21 589.17 506.43 589.17 506.43L590.17 481.94L631.17 482.68Z",
    fill: "#FC9D9D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M629.5 486L604.69 487.78C603.949 487.826 603.225 488.021 602.562 488.354C601.899 488.688 601.31 489.152 600.831 489.72C600.353 490.287 599.994 490.946 599.777 491.656C599.561 492.365 599.49 493.112 599.57 493.85C599.638 494.587 599.559 495.33 599.337 496.035C599.116 496.741 598.755 497.396 598.278 497.961C597.8 498.526 597.215 498.99 596.556 499.327C595.897 499.663 595.178 499.865 594.44 499.92C594.229 499.923 594.022 499.97 593.83 500.058C593.639 500.146 593.469 500.274 593.33 500.432C593.191 500.59 593.088 500.776 593.026 500.978C592.964 501.179 592.944 501.391 592.97 501.6L593.29 507.04C593.311 507.336 593.219 507.629 593.034 507.86C592.849 508.092 592.583 508.245 592.29 508.29C591.77 508.29 591.04 507.88 591.04 507.35L590.04 502.22L588.99 500.55L583 504.23C583 504.23 573.48 489.69 578.08 476.5C580.7 468.97 588.08 466.25 591.79 465.72C592.354 465.67 592.898 465.481 593.373 465.17C593.847 464.86 594.238 464.437 594.51 463.94C595.98 461.54 599.43 457.25 607.28 457.56C609.474 457.576 611.629 458.14 613.55 459.2C615.47 460.26 617.096 461.783 618.28 463.63C618.751 464.409 619.492 464.988 620.361 465.259C621.231 465.53 622.169 465.473 623 465.1C624.652 464.354 626.464 464.03 628.272 464.157C630.08 464.285 631.829 464.859 633.36 465.83C641.32 470.75 638.08 484.66 629.5 486Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M588.37 516.79C588.37 516.79 590.78 516.9 592.03 515.85L588.03 521.92L588.37 516.79Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M626.77 545.36L625.83 536.57C623.43 538.98 616.73 542.43 609.19 540.76C605.409 539.698 602.003 537.595 599.36 534.69C599.313 534.64 599.255 534.6 599.192 534.572C599.128 534.545 599.06 534.531 598.99 534.531C598.921 534.531 598.853 534.545 598.789 534.572C598.725 534.6 598.668 534.64 598.62 534.69C598.524 534.787 598.471 534.918 598.471 535.055C598.471 535.192 598.524 535.323 598.62 535.42C601.995 539.195 606.603 541.645 611.62 542.33C616.07 545.306 621.518 546.395 626.77 545.36V545.36Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M618.19 530C617.034 530.025 615.881 530.128 614.74 530.31C614.546 530.31 614.36 530.233 614.224 530.096C614.087 529.959 614.01 529.773 614.01 529.58C614.01 529.386 614.087 529.201 614.224 529.064C614.36 528.927 614.546 528.85 614.74 528.85C615.825 528.813 616.908 528.706 617.98 528.53C618.079 528.519 618.179 528.53 618.273 528.563C618.367 528.596 618.453 528.649 618.523 528.719C618.594 528.789 618.649 528.874 618.683 528.967C618.717 529.061 618.729 529.161 618.72 529.26C618.93 529.35 618.51 529.77 618.19 530Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M619.34 526.63C613.17 527.57 610.45 524.33 609.51 522.63C609.462 522.555 609.43 522.47 609.414 522.382C609.399 522.294 609.401 522.204 609.421 522.117C609.46 521.94 609.568 521.787 609.72 521.69C609.873 521.593 610.058 521.561 610.234 521.6C610.41 521.64 610.564 521.748 610.66 521.9C611.6 523.57 614.66 527.03 621.96 524.62C622.042 524.577 622.132 524.551 622.224 524.544C622.316 524.536 622.408 524.547 622.496 524.576C622.584 524.605 622.664 524.651 622.734 524.712C622.803 524.773 622.86 524.847 622.9 524.93C622.943 525.013 622.969 525.103 622.977 525.196C622.985 525.288 622.974 525.382 622.945 525.47C622.916 525.559 622.87 525.64 622.809 525.711C622.748 525.781 622.674 525.839 622.59 525.88C621.528 526.214 620.442 526.465 619.34 526.63V526.63Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M614.84 508.21C614.84 507.774 614.711 507.349 614.469 506.987C614.227 506.625 613.883 506.343 613.48 506.176C613.077 506.01 612.635 505.967 612.208 506.053C611.78 506.139 611.389 506.349 611.081 506.658C610.774 506.967 610.565 507.36 610.481 507.787C610.398 508.214 610.443 508.657 610.611 509.059C610.779 509.461 611.062 509.804 611.425 510.044C611.789 510.285 612.215 510.412 612.65 510.41C612.94 510.415 613.228 510.362 613.497 510.253C613.766 510.145 614.01 509.983 614.215 509.777C614.419 509.572 614.58 509.327 614.688 509.058C614.795 508.788 614.847 508.5 614.84 508.21V508.21Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M614.11 507.48C614.132 507.403 614.136 507.321 614.121 507.242C614.106 507.163 614.073 507.088 614.025 507.024C613.977 506.96 613.914 506.908 613.842 506.872C613.77 506.836 613.69 506.817 613.61 506.817C613.529 506.817 613.45 506.836 613.378 506.872C613.306 506.908 613.243 506.96 613.195 507.024C613.146 507.088 613.113 507.163 613.099 507.242C613.084 507.321 613.088 507.403 613.11 507.48C613.088 507.557 613.084 507.639 613.099 507.718C613.113 507.797 613.146 507.872 613.195 507.936C613.243 508 613.306 508.052 613.378 508.088C613.45 508.124 613.529 508.143 613.61 508.143C613.69 508.143 613.77 508.124 613.842 508.088C613.914 508.052 613.977 508 614.025 507.936C614.073 507.872 614.106 507.797 614.121 507.718C614.136 507.639 614.132 507.557 614.11 507.48V507.48Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M632.11 508.21C632.11 507.775 631.981 507.35 631.739 506.988C631.497 506.626 631.154 506.344 630.752 506.177C630.35 506.011 629.908 505.967 629.481 506.052C629.054 506.137 628.662 506.347 628.354 506.654C628.047 506.962 627.837 507.354 627.752 507.781C627.667 508.208 627.711 508.65 627.877 509.052C628.044 509.454 628.326 509.798 628.688 510.039C629.05 510.281 629.475 510.41 629.91 510.41C630.201 510.417 630.49 510.365 630.76 510.256C631.03 510.148 631.275 509.987 631.481 509.781C631.687 509.575 631.848 509.33 631.956 509.06C632.065 508.79 632.117 508.501 632.11 508.21V508.21Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M631.38 507.48C631.343 507.376 631.276 507.287 631.186 507.223C631.097 507.16 630.99 507.126 630.88 507.126C630.77 507.126 630.663 507.16 630.573 507.223C630.484 507.287 630.416 507.376 630.38 507.48C630.416 507.583 630.484 507.673 630.573 507.737C630.663 507.8 630.77 507.834 630.88 507.834C630.99 507.834 631.097 507.8 631.186 507.737C631.276 507.673 631.343 507.583 631.38 507.48V507.48Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M621.12 521.08L618.19 521.29C617.77 521.29 617.46 521.08 617.46 520.77C617.46 520.46 617.67 520.04 617.98 520.04L620.91 519.83C621.089 519.817 621.263 519.769 621.423 519.688C621.583 519.608 621.725 519.497 621.842 519.361C621.959 519.225 622.048 519.068 622.105 518.898C622.161 518.728 622.183 518.549 622.17 518.37C622.157 518.191 622.109 518.017 622.028 517.857C621.948 517.697 621.836 517.555 621.701 517.438C621.565 517.321 621.408 517.232 621.238 517.175C621.068 517.119 620.889 517.097 620.71 517.11C620.29 517.11 619.97 516.9 619.97 516.58C619.97 516.26 620.18 515.85 620.5 515.85C621.203 515.804 621.898 516.027 622.442 516.475C622.987 516.922 623.34 517.561 623.43 518.26C623.482 518.6 623.462 518.947 623.372 519.279C623.281 519.61 623.122 519.919 622.904 520.185C622.686 520.451 622.414 520.668 622.107 520.822C621.8 520.977 621.463 521.064 621.12 521.08V521.08Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M635.15 502.46H604.38C603.521 502.463 602.699 502.805 602.091 503.412C601.484 504.019 601.142 504.842 601.14 505.7V508.21C601.14 510.541 602.066 512.777 603.714 514.426C605.363 516.074 607.598 517 609.93 517C612.261 517 614.497 516.074 616.145 514.426C617.794 512.777 618.72 510.541 618.72 508.21V505.7C618.736 505.334 618.679 504.969 618.552 504.625C618.425 504.282 618.23 503.967 617.98 503.7H621.44C620.982 504.268 620.725 504.971 620.71 505.7V508.21C620.71 510.541 621.636 512.777 623.284 514.426C624.933 516.074 627.168 517 629.5 517C631.831 517 634.067 516.074 635.715 514.426C637.364 512.777 638.29 510.541 638.29 508.21V505.7C638.335 505.272 638.285 504.84 638.145 504.433C638.004 504.026 637.777 503.655 637.477 503.346C637.178 503.037 636.814 502.798 636.412 502.645C636.01 502.491 635.579 502.428 635.15 502.46V502.46ZM617.57 505.59V508.11C617.499 510.061 616.674 511.908 615.268 513.263C613.863 514.618 611.987 515.376 610.035 515.376C608.082 515.376 606.206 514.618 604.801 513.263C603.396 511.908 602.571 510.061 602.5 508.11V505.59C602.512 505.064 602.727 504.562 603.099 504.19C603.472 503.818 603.973 503.603 604.5 503.59H615.5C616.011 503.664 616.486 503.897 616.858 504.256C617.229 504.615 617.478 505.082 617.57 505.59V505.59ZM637.34 508.21C637.377 509.223 637.209 510.232 636.847 511.179C636.485 512.125 635.936 512.989 635.232 513.718C634.529 514.448 633.686 515.028 632.753 515.424C631.821 515.82 630.818 516.025 629.805 516.025C628.791 516.025 627.788 515.82 626.856 515.424C625.923 515.028 625.08 514.448 624.377 513.718C623.674 512.989 623.124 512.125 622.762 511.179C622.4 510.232 622.233 509.223 622.27 508.21V505.7C622.285 505.174 622.5 504.674 622.872 504.303C623.244 503.931 623.744 503.715 624.27 503.7H635.37C635.896 503.713 636.397 503.928 636.77 504.3C637.142 504.672 637.357 505.174 637.37 505.7L637.34 508.21Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M643.52 636.93L660.16 623.32C661.907 621.908 664.084 621.135 666.33 621.13H681.19C681.459 621.102 681.731 621.13 681.989 621.211C682.247 621.291 682.487 621.423 682.692 621.599C682.898 621.775 683.066 621.991 683.186 622.233C683.306 622.476 683.375 622.74 683.39 623.01V623.22C683.382 623.737 683.187 624.233 682.841 624.617C682.496 625.001 682.023 625.247 681.51 625.31L666.65 626.15L684.54 628.56C684.873 628.619 685.188 628.758 685.456 628.964C685.725 629.171 685.94 629.438 686.083 629.745C686.227 630.052 686.294 630.389 686.279 630.728C686.265 631.066 686.169 631.396 686 631.69C685.821 632 685.563 632.256 685.251 632.432C684.94 632.607 684.587 632.697 684.23 632.69H684.12L679.83 632.38C680.079 632.391 680.324 632.452 680.549 632.56C680.774 632.667 680.976 632.818 681.141 633.005C681.307 633.191 681.434 633.409 681.515 633.645C681.595 633.881 681.628 634.131 681.61 634.38C681.553 634.87 681.318 635.321 680.949 635.648C680.58 635.974 680.103 636.153 679.61 636.15L668 636.47L675.11 638.67C675.446 638.817 675.725 639.068 675.906 639.388C676.086 639.707 676.158 640.076 676.11 640.44C676.059 640.792 675.882 641.114 675.612 641.346C675.341 641.578 674.996 641.704 674.64 641.7L665.75 640.86C665.75 640.86 663.55 653 648.69 652.79L645 654.72L639.46 637.87L643.52 636.93Z",
    fill: "#FC9D9D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M569.85 630.44L571.21 652L641.84 637.14L648.54 656.5L560.54 694.9C558.081 695.981 555.402 696.464 552.72 696.309C550.039 696.155 547.432 695.367 545.114 694.011C542.796 692.655 540.832 690.769 539.384 688.507C537.935 686.245 537.043 683.673 536.78 681L533 642L569.85 630.44Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M563.88 653.88H564.09L579.37 650.11L569.53 602.39C569.503 602.248 569.424 602.121 569.309 602.034C569.193 601.947 569.049 601.906 568.905 601.92C568.761 601.934 568.627 602.001 568.53 602.108C568.433 602.216 568.379 602.355 568.38 602.5L571 646.35L563.57 652.35C562.73 653 563.25 653.88 563.88 653.88Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M680.35 646.14V647.81L588.06 629.18L588.26 628.03L680.35 646.14Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M678.78 679.2L678.89 680.36L629.89 665.29L631.67 664.14L678.78 679.2Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M667.38 630.33L680 631.69V632.69L667.23 631.33L667.38 630.33Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M588.06 629.18L683.06 648.33L685.58 681.82L584.81 649.17L586.81 650.11L588.06 629.18Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M575.39 554.43L574.89 574.84L582.89 573.95L577.56 581.06L615.77 612.16L578 553.66L575.39 554.43Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M579.16 650.11L617.25 670.31L631.69 664.13L586.8 650.13L586.9 648.56L579.16 650.11Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M527.88 588.68L533.12 642L536.88 680.93C537.122 683.388 537.896 685.764 539.149 687.892C540.402 690.021 542.104 691.851 544.136 693.254C546.168 694.658 548.482 695.603 550.916 696.021C553.35 696.44 555.846 696.324 558.23 695.68C554.888 694.785 551.897 692.895 549.653 690.261C547.41 687.626 546.021 684.372 545.67 680.93L539.67 633.52L534.44 580.26C534.036 575.953 534.792 571.616 536.63 567.7C533.519 570.174 531.085 573.395 529.555 577.064C528.025 580.732 527.449 584.729 527.88 588.68V588.68Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M552.22 807.32H574.14L574.41 705.26C574.521 703.026 575.18 700.854 576.329 698.936C577.479 697.017 579.083 695.411 581 694.26L631.69 664.13L572 689.77L558.19 695.63C556.311 696.001 554.404 696.211 552.49 696.26L552.22 807.32Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M636.27 595.94C635.85 617.94 637.91 622.76 640.21 624.72C641.909 626.064 643.893 627.001 646.01 627.46L646.3 625.94L646.15 626.7L646.3 625.94C644.445 625.535 642.706 624.718 641.21 623.55C639.55 622.13 637.39 617.73 637.81 595.97L636.27 595.94Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M636.27 595.94C635.85 617.94 637.91 622.76 640.21 624.72C641.909 626.064 643.893 627.001 646.01 627.46L646.3 625.94L646.15 626.7L646.3 625.94C644.445 625.535 642.706 624.718 641.21 623.55C639.55 622.13 637.39 617.73 637.81 595.97L636.27 595.94Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M643.966 625.483L643.684 626.515C643.523 627.107 643.871 627.717 644.462 627.879L647.472 628.701C648.063 628.863 648.674 628.515 648.835 627.923L649.117 626.891C649.279 626.3 648.931 625.69 648.339 625.528L645.33 624.705C644.739 624.543 644.128 624.892 643.966 625.483Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.88 593.18C657.76 607.75 660.82 616.04 659.51 619.24C658.715 620.965 657.547 622.492 656.09 623.71L657.04 624.92C658.712 623.544 660.047 621.803 660.94 619.83C662.5 616.01 659.69 608.08 651.23 592.45L649.88 593.18Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M649.88 593.18C657.76 607.75 660.82 616.04 659.51 619.24C658.715 620.965 657.547 622.492 656.09 623.71L657.04 624.92C658.712 623.544 660.047 621.803 660.94 619.83C662.5 616.01 659.69 608.08 651.23 592.45L649.88 593.18Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M653.968 625.892L654.693 626.68C655.108 627.131 655.81 627.16 656.261 626.745L658.558 624.633C659.009 624.218 659.038 623.516 658.623 623.064L657.899 622.277C657.484 621.826 656.781 621.796 656.33 622.212L654.034 624.324C653.583 624.739 653.553 625.441 653.968 625.892Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.59 591.67C650.069 588.392 648.349 585.209 646.44 582.14C645.43 580.823 644.082 579.804 642.54 579.19C642.24 579.19 641.73 576.58 641.36 574.4C641.04 572.47 640.7 570.23 640.1 569.73C639.77 569.514 639.369 569.435 638.982 569.507C638.594 569.58 638.25 569.8 638.02 570.12C637.64 570.81 638.15 573.02 638.54 574.93C638.99 577.09 639.48 579.75 639.18 579.82C638.063 581.002 637.246 582.436 636.8 584C636.157 587.634 635.789 591.311 635.7 595C635.7 597.33 636.55 597.43 637.23 597.49C638.23 597.58 638.63 596.83 638.74 594.21C638.91 590.06 638.74 583.21 641.44 582.55C644.19 582.17 646.95 588.83 648.75 592.48C649.88 594.76 650.44 594.87 651.32 594.48C651.94 594.15 652.54 593.71 651.59 591.67Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M637.387 562.138L635.955 562.584L638.176 569.717L639.609 569.271L637.387 562.138Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M576.99 554L576.67 573.06H584.66L579.33 580.17L614.88 610.38L581.11 552.63L576.99 554Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M637.06 552.54L642.04 570.37L634.9 571.35L641.11 576.43L614.88 612.16L634.63 552.44L637.06 552.54Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M635.58 552.51L640.1 569.2L633.16 570.96L639.37 576.04L615.25 610.4L631.7 552.21L635.58 552.51Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M669.08 746.11L651.75 751.67L634.43 746.11V708.13H669.08V746.11Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M667.3 744.56L651.75 749.89L636.2 744.56V708.13H667.3V744.56Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M585.28 514.7L588.56 501.91L599.56 516.67L595.3 530.81L585.28 514.7ZM589 504.46L586.41 514.55L595 528.11L598.39 516.85L589 504.46Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.19 514.63C598.19 514.63 615.42 520.75 634.55 517.81C634.55 517.81 632.99 536.12 620.37 541.81C620.37 541.81 604.37 546.56 594.21 529.45C594.21 529.47 598 521.71 598.19 514.63Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M595.49 526.42C597.001 522.659 597.912 518.684 598.19 514.64C598.19 514.64 615.42 520.76 634.55 517.82C634.55 517.82 633.75 527.22 628.65 534.66C628.63 534.65 610.55 542.93 595.49 526.42Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M634.54 517.81L633.13 524.81C627.185 526.585 620.944 527.145 614.779 526.458C608.613 525.771 602.648 523.85 597.24 520.81C597.703 518.993 598.004 517.14 598.14 515.27L598.26 514.59C599.46 515.07 616.11 520.64 634.54 517.81Z",
    fill: "white"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M589.729 502.14C589.5 501.447 589.12 500.815 588.615 500.287C588.111 499.76 587.496 499.351 586.815 499.091C586.133 498.83 585.402 498.725 584.675 498.782C583.948 498.839 583.242 499.057 582.609 499.42C576.539 502.14 577.699 516.06 588.059 516.79C593.499 517.21 592.449 514.07 591.509 509.88L589.729 502.14Z",
    fill: "#FC9D9D"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M582.19 503.19C583.041 502.579 584.092 502.314 585.13 502.45C585.628 502.573 586.097 502.794 586.509 503.1C586.921 503.405 587.268 503.789 587.53 504.23C588.159 505.431 588.517 506.755 588.58 508.11L588.79 509.36C588.79 509.78 588.58 510.09 588.26 510.09C587.94 510.09 587.53 509.88 587.53 509.57L587.32 508.31C587.281 507.203 586.958 506.125 586.38 505.18C585.86 504.44 585.44 503.92 584.92 503.92C584.57 503.84 584.205 503.845 583.857 503.935C583.509 504.026 583.188 504.199 582.92 504.44C582.5 504.55 582.18 504.55 581.98 504.23C581.88 503.61 582 503.29 582.19 503.19Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M888.17 1085.39L838.82 1097.17L855.61 1078.77C858.44 1075.68 861.32 1071.71 860.61 1067.58L859.67 1052.25L886.74 1046.6L888.17 1085.39Z",
    fill: "#FC9D9D"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M882.11 1068.47L882.05 1068.18C882.015 1067.76 881.896 1067.34 881.7 1066.96C881.504 1066.59 881.235 1066.25 880.909 1065.98C880.583 1065.7 880.205 1065.5 879.799 1065.37C879.392 1065.25 878.964 1065.2 878.54 1065.24L860.63 1066.66L860.15 1063.48L886.63 1057.85L888.14 1084.3L866 1086.51L872.53 1082.14C877 1079.11 882.84 1073.78 882.11 1068.47Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M889.74 1075.9L893.85 1095.23C894.015 1095.97 894.031 1096.73 893.897 1097.48C893.763 1098.22 893.481 1098.93 893.068 1099.57C892.656 1100.2 892.12 1100.75 891.494 1101.17C890.867 1101.6 890.162 1101.89 889.42 1102.04L861.89 1107.9H821.89C821.578 1107.97 821.255 1107.98 820.94 1107.92C820.625 1107.86 820.325 1107.75 820.056 1107.57C819.788 1107.4 819.557 1107.17 819.377 1106.91C819.198 1106.64 819.073 1106.34 819.01 1106.03C818.532 1103.78 818.773 1101.43 819.699 1099.32C820.625 1097.22 822.188 1095.45 824.17 1094.28L843.25 1091.07L855.48 1075.77C856.271 1074.83 857.363 1074.2 858.569 1073.98C859.775 1073.76 861.02 1073.97 862.09 1074.57L872 1080C872.725 1080.37 873.526 1080.56 874.34 1080.56C875.153 1080.56 875.955 1080.37 876.68 1080L886.54 1074.42C886.838 1074.24 887.175 1074.14 887.522 1074.12C887.868 1074.11 888.214 1074.17 888.529 1074.32C888.844 1074.46 889.119 1074.68 889.33 1074.96C889.541 1075.24 889.681 1075.56 889.74 1075.9V1075.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M889.42 1102L861.66 1107.9H821.89C821.578 1107.97 821.255 1107.98 820.94 1107.92C820.625 1107.86 820.325 1107.75 820.056 1107.57C819.788 1107.4 819.557 1107.17 819.377 1106.91C819.198 1106.64 819.073 1106.34 819.01 1106.03C818.831 1105.23 818.757 1104.41 818.79 1103.59L859.03 1103.49L893.94 1096.07C894.046 1097.44 893.644 1098.8 892.81 1099.9C891.977 1100.99 890.77 1101.74 889.42 1102V1102Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M857.5 1083.45C857.575 1083.43 857.644 1083.4 857.703 1083.35C857.762 1083.3 857.809 1083.24 857.84 1083.17C857.907 1083.03 857.925 1082.87 857.893 1082.71C857.86 1082.56 857.778 1082.42 857.66 1082.32L852.75 1078.88C852.619 1078.83 852.475 1078.82 852.34 1078.86C852.206 1078.91 852.09 1078.99 852.011 1079.11C851.932 1079.22 851.894 1079.36 851.905 1079.5C851.916 1079.64 851.974 1079.78 852.07 1079.88L856.98 1083.32C857.133 1083.42 857.317 1083.47 857.5 1083.45V1083.45Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M854.88 1086.59C854.953 1086.57 855.021 1086.54 855.08 1086.49C855.139 1086.45 855.187 1086.39 855.22 1086.32C855.287 1086.18 855.306 1086.01 855.274 1085.86C855.241 1085.7 855.159 1085.56 855.04 1085.46L850.13 1082.03C849.986 1081.96 849.825 1081.94 849.67 1081.98C849.515 1082.01 849.374 1082.09 849.27 1082.21C849.203 1082.35 849.185 1082.51 849.219 1082.67C849.254 1082.82 849.338 1082.96 849.46 1083.06L854.37 1086.5C854.522 1086.59 854.705 1086.63 854.88 1086.59Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M852.16 1089.7C852.234 1089.68 852.303 1089.65 852.362 1089.61C852.422 1089.56 852.469 1089.5 852.5 1089.43C852.568 1089.29 852.587 1089.13 852.554 1088.97C852.522 1088.81 852.44 1088.67 852.32 1088.57L847.41 1085.14C847.267 1085.07 847.105 1085.05 846.95 1085.09C846.795 1085.12 846.655 1085.2 846.55 1085.32C846.482 1085.46 846.464 1085.63 846.498 1085.78C846.533 1085.94 846.618 1086.08 846.74 1086.18L851.65 1089.61C851.803 1089.7 851.985 1089.74 852.16 1089.7Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M850.79 758.46L833.75 906.29L856.77 1062.88H890.85L878.88 906.29L905.59 806.82L901.91 755.24L850.79 758.46Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M951.24 1091.1L900.51 1092.37L920.76 1077.86C924.17 1075.42 925.39 1071.63 925.58 1067.44L924.58 1051.57L952.23 1051.67L951.24 1091.1Z",
    fill: "#FC9D9D"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M945.59 1072.6V1072.31C945.644 1071.89 945.614 1071.46 945.501 1071.05C945.387 1070.64 945.193 1070.25 944.93 1069.92C944.666 1069.58 944.339 1069.3 943.966 1069.1C943.594 1068.89 943.184 1068.76 942.76 1068.71L925 1066.37L925.19 1063.16H952.26L951.48 1090.03L929.38 1087.59L936.68 1084.67C939.132 1083.67 941.262 1082.02 942.834 1079.89C944.406 1077.76 945.36 1075.24 945.59 1072.6V1072.6Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M892.68 1089.72C892.68 1089.72 875.18 1094.54 876.59 1104.72L895 1100L892.68 1089.72Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M954.74 1082.14V1101.91C954.747 1102.67 954.603 1103.42 954.317 1104.11C954.031 1104.81 953.608 1105.45 953.074 1105.98C952.54 1106.52 951.904 1106.94 951.205 1107.23C950.505 1107.51 949.756 1107.66 949 1107.65H881.71C881.39 1107.65 881.073 1107.59 880.777 1107.47C880.481 1107.35 880.212 1107.17 879.986 1106.94C879.76 1106.72 879.581 1106.45 879.46 1106.15C879.339 1105.86 879.278 1105.54 879.28 1105.22C879.282 1102.92 880.007 1100.67 881.353 1098.8C882.698 1096.93 884.597 1095.53 886.78 1094.8L901.97 1089.8L921.25 1074.91C922.217 1074.16 923.415 1073.77 924.639 1073.8C925.863 1073.84 927.037 1074.3 927.96 1075.1L936.53 1082.4C937.158 1082.92 937.902 1083.28 938.699 1083.46C939.496 1083.63 940.323 1083.61 941.11 1083.4L951.92 1079.99C952.252 1079.88 952.607 1079.85 952.953 1079.9C953.3 1079.96 953.627 1080.1 953.906 1080.31C954.185 1080.52 954.407 1080.8 954.553 1081.12C954.698 1081.44 954.763 1081.79 954.74 1082.14V1082.14Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M949 1107.65H881.71C881.39 1107.65 881.073 1107.59 880.777 1107.47C880.481 1107.35 880.212 1107.17 879.986 1106.94C879.76 1106.72 879.581 1106.45 879.46 1106.15C879.339 1105.86 879.278 1105.54 879.28 1105.22C879.277 1104.4 879.374 1103.58 879.57 1102.78H954.64C954.463 1104.14 953.791 1105.39 952.75 1106.29C951.71 1107.19 950.375 1107.67 949 1107.65Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M921.64 1082.82C921.715 1082.82 921.789 1082.8 921.856 1082.77C921.924 1082.74 921.983 1082.69 922.03 1082.63C922.123 1082.5 922.173 1082.35 922.173 1082.19C922.173 1082.03 922.123 1081.88 922.03 1081.75L917.94 1077.37C917.812 1077.28 917.658 1077.23 917.5 1077.23C917.342 1077.23 917.188 1077.28 917.06 1077.37C916.963 1077.5 916.91 1077.65 916.91 1077.81C916.91 1077.97 916.963 1078.12 917.06 1078.25L921.15 1082.63C921.284 1082.75 921.459 1082.82 921.64 1082.82V1082.82Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M918.42 1085.36C918.496 1085.36 918.571 1085.34 918.638 1085.31C918.706 1085.27 918.765 1085.22 918.81 1085.16C918.908 1085.03 918.96 1084.88 918.96 1084.72C918.96 1084.56 918.908 1084.41 918.81 1084.28L914.72 1079.9C914.594 1079.81 914.442 1079.76 914.285 1079.76C914.129 1079.76 913.976 1079.81 913.85 1079.9C913.753 1080.03 913.7 1080.18 913.7 1080.34C913.7 1080.5 913.753 1080.65 913.85 1080.78L917.94 1085.16C918.069 1085.29 918.241 1085.36 918.42 1085.36V1085.36Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M915.12 1087.84C915.194 1087.84 915.267 1087.82 915.333 1087.78C915.399 1087.75 915.456 1087.7 915.5 1087.64C915.597 1087.51 915.65 1087.36 915.65 1087.2C915.65 1087.04 915.597 1086.89 915.5 1086.76L911.42 1082.38C911.292 1082.29 911.138 1082.24 910.98 1082.24C910.822 1082.24 910.668 1082.29 910.54 1082.38C910.442 1082.51 910.39 1082.66 910.39 1082.82C910.39 1082.98 910.442 1083.13 910.54 1083.26L914.63 1087.64C914.763 1087.76 914.937 1087.84 915.12 1087.84V1087.84Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M897.14 805.21L866.91 907.21L879.43 1062.87H891.77L879.05 908.47L904.7 810.42L903.59 805.36C903.431 804.633 903.033 803.981 902.458 803.508C901.884 803.035 901.168 802.768 900.424 802.751C899.68 802.733 898.952 802.966 898.357 803.412C897.761 803.858 897.333 804.491 897.14 805.21V805.21Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M955.17 752.26V1062.88H922.17L892.53 755.54L955.17 752.26Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M849.57 769.71L955.17 760.22L955.45 754.37L850.41 761.96L849.57 769.71Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M913.2 572.87L876.35 572L841.47 583C838.2 583.818 835.263 585.628 833.063 588.181C830.863 590.734 829.506 593.905 829.18 597.26L822.93 656.72L849.18 659.94L847.1 762.15L957.63 755.7L961.55 654.38L977.21 651.62L964.07 592.13C963.326 588.776 961.583 585.726 959.072 583.382C956.56 581.039 953.397 579.511 950 579L913.2 572.87Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.88 560.45C876.409 561.428 874.629 561.83 872.88 561.58C864.75 561.04 858.58 560.53 857.17 552.47C855.09 539.78 855.17 511.26 863.78 494.17C871.05 497.09 872.28 498.61 872.28 498.61C872.28 498.61 882.28 494.5 882.48 494.37C882.44 494.26 891.08 549.92 877.88 560.45Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.32 549.84L901.63 481.2C905.04 480.33 910.99 484.36 912.79 486.04C927.18 499.65 933.22 529.99 933.31 550.62C933.41 558.62 928.42 560.15 920.77 562.4C913.12 564.65 904.1 566.27 900.37 562.69C898.55 560.79 902.32 549.84 902.32 549.84Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M912.2 572.81L908.2 531.87L878.1 544.87L876.58 572.61L890.05 593.76C890.273 594.11 890.575 594.403 890.932 594.614C891.288 594.826 891.69 594.95 892.104 594.978C892.518 595.005 892.933 594.934 893.314 594.771C893.696 594.608 894.033 594.358 894.3 594.04L912.2 572.81Z",
    fill: "#FC9D9D"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M877.49 554.49L877.97 547.77L889.24 550.09L889.14 550.21C892.145 549.795 895.047 548.829 897.7 547.36C897.881 547.258 898.094 547.232 898.294 547.287C898.494 547.342 898.663 547.475 898.765 547.655C898.867 547.835 898.894 548.049 898.838 548.249C898.783 548.448 898.651 548.618 898.47 548.72C895.465 550.407 892.147 551.465 888.72 551.83C888.29 551.83 887.85 551.9 887.4 551.91C883.3 555 877.49 554.49 877.49 554.49Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M884.636 679.913L882.09 678.443L866.415 705.593L868.961 707.063L884.636 679.913Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M887.28 550.1H888.81C900.13 549.93 909.43 539.62 909.15 528.1L908.59 498.87C908.556 497.036 907.803 495.289 906.494 494.004C905.185 492.719 903.424 492 901.59 492L874.78 492.32C873.605 492.342 872.447 492.597 871.371 493.071C870.296 493.545 869.326 494.228 868.517 495.081C867.709 495.933 867.077 496.938 866.661 498.036C866.244 499.135 866.05 500.306 866.09 501.48L866.62 528.71C866.93 540.1 875.49 550.61 887.28 550.1Z",
    fill: "#FC9D9D"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M888.6 535.52L887.97 536.76C887.557 537.49 886.972 538.107 886.265 538.558C885.558 539.01 884.751 539.281 883.915 539.348C883.08 539.415 882.24 539.276 881.47 538.943C880.701 538.611 880.024 538.095 879.5 537.44L878.5 536.16C878.3 535.88 878.41 535.5 878.75 535.51L888.18 534.97C888.5 534.87 888.73 535.25 888.6 535.52Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M889.83 524.55C889.385 524.632 888.925 524.579 888.509 524.4C888.093 524.22 887.739 523.921 887.493 523.54C887.248 523.16 887.12 522.715 887.127 522.261C887.134 521.808 887.276 521.367 887.534 520.995C887.791 520.622 888.154 520.334 888.575 520.168C888.997 520.001 889.458 519.964 889.901 520.059C890.344 520.155 890.749 520.38 891.064 520.706C891.379 521.032 891.59 521.444 891.67 521.89C891.776 522.486 891.641 523.1 891.297 523.598C890.952 524.096 890.426 524.438 889.83 524.55Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M888.5 522.94C888.444 522.95 888.387 522.95 888.331 522.938C888.275 522.927 888.223 522.904 888.176 522.872C888.129 522.84 888.089 522.799 888.058 522.751C888.027 522.704 888.005 522.651 887.995 522.595C887.984 522.539 887.985 522.482 887.997 522.426C888.008 522.371 888.031 522.318 888.063 522.271C888.095 522.224 888.136 522.184 888.183 522.153C888.231 522.122 888.284 522.1 888.34 522.09C888.396 522.078 888.455 522.078 888.511 522.09C888.568 522.101 888.621 522.124 888.669 522.157C888.717 522.189 888.757 522.231 888.788 522.28C888.819 522.329 888.84 522.383 888.85 522.44C888.867 522.552 888.841 522.667 888.776 522.761C888.71 522.854 888.611 522.918 888.5 522.94Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M872.33 525C871.886 525.08 871.429 525.026 871.016 524.846C870.602 524.666 870.252 524.368 870.008 523.988C869.764 523.609 869.639 523.166 869.647 522.715C869.655 522.264 869.797 521.826 870.054 521.456C870.311 521.085 870.672 520.8 871.091 520.634C871.511 520.469 871.97 520.432 872.411 520.528C872.851 520.624 873.253 520.848 873.567 521.172C873.88 521.497 874.09 521.906 874.17 522.35C874.225 522.645 874.221 522.948 874.157 523.241C874.094 523.535 873.974 523.812 873.803 524.059C873.632 524.305 873.413 524.515 873.161 524.677C872.908 524.838 872.626 524.948 872.33 525V525Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M870.87 523.27C870.814 523.28 870.756 523.279 870.701 523.267C870.646 523.255 870.593 523.232 870.547 523.199C870.5 523.166 870.461 523.125 870.43 523.077C870.4 523.029 870.379 522.976 870.37 522.92C870.355 522.836 870.366 522.75 870.4 522.673C870.435 522.595 870.491 522.529 870.563 522.484C870.635 522.438 870.718 522.415 870.803 522.417C870.888 522.419 870.97 522.446 871.04 522.494C871.109 522.543 871.163 522.611 871.194 522.69C871.225 522.77 871.232 522.856 871.213 522.939C871.195 523.022 871.153 523.098 871.092 523.156C871.03 523.215 870.953 523.255 870.87 523.27V523.27Z",
    fill: "white"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M881.87 531.77L884.87 531.5C885.21 531.5 885.55 531.14 885.44 530.83C885.33 530.52 885.08 530.15 884.77 530.26L881.77 530.53C881.594 530.548 881.417 530.531 881.249 530.48C881.08 530.429 880.923 530.346 880.786 530.234C880.65 530.123 880.537 529.986 880.453 529.831C880.37 529.675 880.317 529.505 880.3 529.33C880.282 529.155 880.299 528.978 880.35 528.809C880.4 528.64 880.484 528.483 880.595 528.346C880.707 528.21 880.844 528.097 880.999 528.013C881.154 527.93 881.324 527.878 881.5 527.86C881.85 527.86 882.18 527.5 882.07 527.19C881.96 526.88 881.71 526.51 881.41 526.62C880.705 526.701 880.059 527.053 879.609 527.601C879.159 528.15 878.941 528.853 879 529.56C879.043 529.894 879.151 530.215 879.319 530.507C879.487 530.799 879.71 531.054 879.977 531.26C880.243 531.465 880.548 531.616 880.872 531.703C881.197 531.791 881.536 531.813 881.87 531.77V531.77Z",
    fill: "black"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M889.25 694.45L875.43 687.08L864.82 687.15L896.52 711.95L889.25 694.45Z",
    fill: "#FC9D9D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M860.7 505.82L859.51 505.93C865.75 474.87 898.35 472.01 912.91 486.14C921.69 494.7 926.48 509.54 926.48 509.54C924.41 515.42 917.69 520.54 915.78 524.64C914.97 526.47 912.15 518.54 910.64 517.64C910.41 517.56 908.84 519.45 907.76 520.76C907.621 520.955 907.428 521.106 907.205 521.194C906.982 521.282 906.739 521.303 906.504 521.255C906.269 521.208 906.053 521.093 905.882 520.925C905.711 520.758 905.592 520.544 905.54 520.31C904.676 516.571 904.457 512.713 904.89 508.9L905.34 505.47C897.86 503.78 875.18 497.29 870.16 496.13C868.92 495.81 868.02 497.75 867.8 498.97L865.33 517.18L862 508.21L860.7 505.82Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.33 699.98L843.65 715.21L822.72 695.47L818.33 699.98Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M908.2 532.24L904.77 531.8L908.159 539.89L908.2 532.24Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M867.78 499.37C885.78 493.97 884.89 515.6 903.54 510.7C921.02 506.09 903.28 489.45 903.28 489.45L887.36 488.56L866.46 492.75L867.78 499.37Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.2 532.24C908.2 532.24 906.66 550.63 898.29 563.76C898.29 563.76 911.35 565.58 920.99 562.38C929.88 559.46 908.2 532.24 908.2 532.24Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M961.33 681L938.06 617.85L935.06 618.74C934.481 618.912 933.985 619.29 933.665 619.801C933.345 620.313 933.222 620.924 933.32 621.52L944.12 686.74L943.53 756.5L957.6 755.5L961.33 681Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M973.91 641.77L982.42 684.17C982.978 687.016 982.389 689.966 980.782 692.38C979.176 694.794 976.681 696.476 973.84 697.06L893.84 710.11L888.78 694.91L951.41 674.65L945.88 648.86L973.91 641.77Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.74 702.37L849.18 659.91L827.74 657.3L827.54 700.9",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(235, 244, 248)"
    }
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M840.39 658.72L840.43 698.13L850.59 698.37L848.72 659.45L840.39 658.72Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M934.84 618.46L944.05 658.99L978.13 651.62L968.53 612.31L934.84 618.46Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.05 676.57L805.2 672.35H841.39L844.34 676.57H808.05Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.44 722.08H852.4L795.3 675.11H854.42L911.44 722.08Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M911.44 722.08H852.4L795.3 675.11H854.42L911.44 722.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M911.35 722.08H909.51V723.46H911.35V722.08Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M911.35 722.08H909.51V723.46H911.35V722.08Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M794.38 676.49V675.11H796.87L797.14 676.95L794.38 676.49Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M794.38 676.49V675.11H796.87L797.14 676.95L794.38 676.49Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M911.44 723.46H854.16L794.29 676.49H854.33L911.44 723.46Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M848.72 659.45V625C848.72 624.808 848.682 624.618 848.609 624.441C848.536 624.264 848.428 624.103 848.293 623.968C848.157 623.832 847.996 623.725 847.819 623.651C847.642 623.578 847.452 623.54 847.26 623.54V623.54C846.901 623.54 846.555 623.671 846.286 623.908C846.017 624.146 845.844 624.474 845.8 624.83L841.41 659.08L848.72 659.45Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M799.3 681.76C799.3 681.76 800.45 695.76 816.5 700.12L822.72 695.47L808.92 681.47L799.3 681.76Z",
    fill: "#FC9D9D"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M799.3 681.76C799.3 681.76 800.45 695.76 816.5 700.12L822.72 695.47L808.92 681.47L799.3 681.76Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M809.85 681.4L800.11 681.73C799.559 681.746 799.029 681.951 798.61 682.31V682.31C798.334 682.543 798.112 682.835 797.962 683.164C797.813 683.494 797.738 683.852 797.743 684.214C797.749 684.576 797.835 684.932 797.996 685.256C798.156 685.581 798.386 685.866 798.67 686.09V686.09C799.228 686.531 799.873 686.849 800.563 687.021C801.252 687.194 801.971 687.217 802.67 687.09L813.18 685.09C813.424 685.034 813.647 684.911 813.824 684.734C814.001 684.557 814.125 684.334 814.18 684.09V684.09C814.23 683.851 814.212 683.603 814.129 683.373C814.046 683.144 813.901 682.942 813.71 682.79V682.79C812.627 681.887 811.26 681.395 809.85 681.4V681.4Z",
    fill: "#FC9D9D"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M813.7 685.19L803.16 688C802.616 688.094 802.119 688.369 801.75 688.78V688.78C801.51 689.05 801.332 689.369 801.231 689.716C801.129 690.063 801.105 690.428 801.162 690.785C801.218 691.142 801.353 691.481 801.557 691.78C801.761 692.078 802.028 692.328 802.34 692.51V692.51C802.958 692.869 803.645 693.091 804.356 693.161C805.067 693.232 805.784 693.15 806.46 692.92L817.52 688.26C817.765 688.178 817.98 688.025 818.137 687.82C818.294 687.615 818.386 687.368 818.4 687.11V687.11C818.414 686.868 818.362 686.626 818.249 686.411C818.136 686.196 817.968 686.016 817.76 685.89V685.89C816.532 685.185 815.094 684.937 813.7 685.19V685.19Z",
    fill: "#FC9D9D"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M818 688.47L807.84 692.47C807.311 692.629 806.85 692.96 806.53 693.41V693.41C806.321 693.705 806.18 694.042 806.118 694.398C806.055 694.753 806.073 695.119 806.168 695.467C806.264 695.815 806.436 696.138 806.671 696.411C806.907 696.685 807.2 696.903 807.53 697.05V697.05C808.18 697.346 808.886 697.499 809.6 697.499C810.314 697.499 811.02 697.346 811.67 697.05L822.13 691.17C822.362 691.059 822.557 690.882 822.69 690.662C822.824 690.442 822.89 690.187 822.88 689.93C822.869 689.686 822.79 689.45 822.652 689.249C822.515 689.047 822.323 688.889 822.1 688.79V688.79C820.815 688.199 819.361 688.085 818 688.47Z",
    fill: "#FC9D9D"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M820.69 691.93L814.12 697.21C813.764 697.449 813.499 697.801 813.37 698.21V698.21C813.284 698.475 813.257 698.756 813.293 699.033C813.328 699.31 813.424 699.575 813.574 699.81C813.724 700.046 813.925 700.245 814.161 700.393C814.397 700.542 814.663 700.636 814.94 700.67V700.67C815.482 700.727 816.031 700.667 816.548 700.495C817.066 700.322 817.54 700.041 817.94 699.67L824.32 692.95C824.467 692.815 824.57 692.639 824.617 692.445C824.663 692.25 824.65 692.047 824.58 691.86C824.517 691.683 824.406 691.528 824.259 691.411C824.113 691.294 823.936 691.221 823.75 691.2C822.676 691.08 821.594 691.338 820.69 691.93Z",
    fill: "#FC9D9D"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M893.85 710.11L973.85 697.06C976.69 696.476 979.185 694.794 980.792 692.38C982.399 689.966 982.988 687.016 982.43 684.17L980.61 675.11C980.61 675.11 982.28 688.92 968.47 692.61L893 707.53L893.85 710.11Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M940.32 762.15L948.41 1062.88H955.33V759.85L940.32 762.15Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M871.29 573.33L889.06 601.61C889.343 602.058 889.729 602.432 890.185 602.701C890.642 602.97 891.156 603.127 891.685 603.157C892.214 603.187 892.743 603.091 893.227 602.876C893.712 602.661 894.138 602.333 894.47 601.92L917.34 573.33",
    stroke: "black",
    strokeWidth: 0.92,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M903 540.38L899 527.08L910.39 518.19L913.48 530.19L903 540.38ZM900.08 527.24L903.27 537.83L912.4 530.08L910 520.59L900.08 527.24Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.28 525.15C900.28 525.15 884.07 530.91 866.06 528.15C866.06 528.15 867.53 545.37 879.41 550.75C879.41 550.75 894.49 555.21 904.03 539.12C904 539.12 900.5 531.82 900.28 525.15Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M902.82 536.24C901.404 532.698 900.55 528.956 900.29 525.15C900.29 525.15 884.08 530.91 866.07 528.15C866.07 528.15 866.83 536.99 871.63 543.99C871.64 544 888.65 551.78 902.82 536.24Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M866.07 528.15L867.4 534.76C872.994 536.429 878.866 536.956 884.667 536.31C890.469 535.664 896.081 533.858 901.17 531C900.73 529.296 900.446 527.555 900.32 525.8L900.21 525.16C899.08 525.57 883.41 530.81 866.07 528.15Z",
    fill: "white"
  }))), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M906.21 532C906.21 532 915.93 534.36 919.52 525C923.11 515.64 911.4 511.89 908.04 521.38L905.04 531.83L906.21 532Z",
    fill: "#FC9D9D"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M917.35 519.25C916.993 518.849 916.553 518.53 916.061 518.314C915.569 518.099 915.037 517.992 914.5 518C913.962 518.046 913.441 518.21 912.974 518.482C912.507 518.753 912.106 519.125 911.8 519.57C910.942 520.634 910.352 521.89 910.08 523.23L909.84 524.23C909.7 525.01 910.94 525.44 911.18 524.54L911.41 523.43C911.64 522.345 912.101 521.322 912.76 520.43C912.972 520.155 913.237 519.925 913.54 519.753C913.842 519.581 914.175 519.472 914.52 519.43C915.257 519.484 915.947 519.808 916.46 520.34C916.583 520.444 916.739 520.502 916.9 520.502C917.061 520.502 917.217 520.444 917.34 520.34C917.467 520.187 917.538 519.996 917.54 519.797C917.542 519.598 917.475 519.405 917.35 519.25V519.25Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M909.49 530.92C909.093 530.965 908.692 530.89 908.338 530.705C907.985 530.52 907.694 530.234 907.505 529.883C907.315 529.532 907.235 529.132 907.274 528.735C907.314 528.338 907.471 527.961 907.726 527.654C907.981 527.347 908.323 527.124 908.706 527.012C909.089 526.901 909.497 526.906 909.877 527.029C910.257 527.151 910.591 527.384 910.838 527.698C911.084 528.011 911.231 528.392 911.26 528.79C911.296 529.305 911.133 529.814 910.803 530.211C910.473 530.608 910.002 530.862 909.49 530.92Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M908.47 530.47C909.028 530.56 909.598 530.425 910.057 530.095C910.516 529.765 910.826 529.267 910.92 528.71C910.995 528.311 910.957 527.899 910.81 527.52C911.034 527.736 911.205 528.001 911.31 528.294C911.414 528.587 911.448 528.901 911.41 529.21C911.382 529.47 911.299 529.722 911.168 529.949C911.037 530.175 910.859 530.372 910.647 530.526C910.435 530.679 910.193 530.787 909.937 530.841C909.681 530.895 909.416 530.895 909.16 530.84C908.768 530.786 908.41 530.586 908.16 530.28C908.14 530.5 908.25 530.49 908.47 530.47Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M862.2 521.9C862.182 523.091 862.4 524.274 862.839 525.381C863.278 526.488 863.932 527.498 864.761 528.353C865.591 529.208 866.581 529.891 867.675 530.363C868.768 530.835 869.944 531.087 871.135 531.105C872.326 531.123 873.509 530.906 874.616 530.466C875.724 530.027 876.733 529.374 877.588 528.544C878.443 527.714 879.126 526.724 879.598 525.631C880.07 524.537 880.323 523.361 880.34 522.17C880.369 520.51 879.951 518.873 879.13 517.43C880.592 516.917 882.176 516.861 883.67 517.27C883.298 518.198 883.111 519.19 883.12 520.19C883.093 521.984 883.598 523.745 884.571 525.252C885.545 526.758 886.943 527.942 888.59 528.654C890.236 529.366 892.057 529.574 893.821 529.251C895.586 528.928 897.215 528.089 898.503 526.841C899.791 525.592 900.679 523.989 901.056 522.236C901.434 520.482 901.282 518.656 900.621 516.988C899.961 515.321 898.82 513.886 897.345 512.867C895.869 511.847 894.124 511.288 892.33 511.26C890.661 511.268 889.024 511.727 887.593 512.588C886.162 513.448 884.99 514.679 884.2 516.15C882.347 515.587 880.356 515.689 878.57 516.44C877.745 515.362 876.687 514.484 875.475 513.873C874.263 513.261 872.928 512.932 871.57 512.91C869.15 512.908 866.822 513.843 865.075 515.519C863.329 517.195 862.298 519.481 862.2 521.9V521.9ZM884.36 520.24C884.38 518.676 884.864 517.154 885.75 515.865C886.636 514.577 887.884 513.58 889.337 513.002C890.789 512.423 892.381 512.289 893.91 512.615C895.439 512.942 896.837 513.715 897.927 514.837C899.016 515.959 899.748 517.378 900.03 518.917C900.312 520.455 900.131 522.042 899.511 523.477C898.89 524.912 897.857 526.131 896.543 526.979C895.23 527.827 893.694 528.266 892.13 528.24C890.043 528.198 888.056 527.334 886.601 525.837C885.147 524.339 884.341 522.328 884.36 520.24ZM863.52 521.81C863.54 520.246 864.024 518.724 864.91 517.435C865.796 516.147 867.044 515.15 868.497 514.572C869.949 513.993 871.541 513.859 873.07 514.185C874.599 514.512 875.997 515.285 877.087 516.407C878.176 517.529 878.908 518.948 879.19 520.487C879.472 522.025 879.291 523.612 878.671 525.047C878.05 526.482 877.017 527.701 875.703 528.549C874.39 529.397 872.854 529.836 871.29 529.81C870.252 529.804 869.226 529.591 868.271 529.184C867.316 528.776 866.452 528.183 865.728 527.438C865.005 526.694 864.438 525.813 864.058 524.846C863.679 523.88 863.496 522.848 863.52 521.81V521.81Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M825.74 507.21C830.368 502.072 832.952 495.415 833 488.5C833 471.66 817.55 458 798.5 458C779.45 458 764 471.66 764 488.5C764 505.34 779.45 519 798.5 519C805.09 519.028 811.572 517.328 817.3 514.07L830 520L825.74 507.21Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M830.84 520.72L817.32 514.41C811.572 517.63 805.088 519.307 798.5 519.28C779.2 519.28 763.5 505.37 763.5 488.28C763.5 471.19 779.2 457.28 798.5 457.28C817.8 457.28 833.5 471.18 833.5 488.28C833.472 495.221 830.912 501.913 826.3 507.1L830.84 520.72ZM817.27 513.29L829.16 518.83L825.16 506.83L825.35 506.62C829.916 501.584 832.459 495.038 832.49 488.24C832.49 471.7 817.24 458.24 798.49 458.24C779.74 458.24 764.49 471.7 764.49 488.24C764.49 504.78 779.74 518.24 798.49 518.24C804.992 518.268 811.387 516.592 817.04 513.38L817.27 513.29Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.7 482.71C814.78 478.62 810.89 475.1 806.7 475.51C805.468 475.68 804.284 476.099 803.218 476.74C802.153 477.381 801.228 478.231 800.5 479.24C799.965 479.91 799.48 480.618 799.05 481.36C798.623 480.617 798.138 479.908 797.6 479.24C796.874 478.231 795.952 477.38 794.888 476.737C793.824 476.094 792.641 475.673 791.41 475.5C787.23 475.08 783.33 478.6 782.41 482.69C781.49 486.78 783.02 491.13 785.54 494.48C788.869 499.158 793.79 502.461 799.38 503.77C804.07 502.69 810.02 497.85 812.54 494.5C815.06 491.15 816.63 486.81 815.7 482.71Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(193, 187, 239)"
    }
  }), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M814.93 490.31H814.79H814.39H812.83H807.09L807.19 490.24C806.68 492.09 806.09 494.24 805.43 496.65L805.33 497.03L805.2 496.65L801.84 487C801.47 485.93 801.1 484.88 800.75 483.85H800.99C799.66 486.12 798.4 488.28 797.24 490.24V490.3H797.17L787.08 490.25H784.22H783.47H783.21C783.296 490.241 783.383 490.241 783.47 490.25H784.22H787.08L797.17 490.2L797.06 490.27L800.79 483.86L800.94 483.61L801.03 483.88C801.39 484.88 801.75 485.96 802.13 487.03L805.46 496.69H805.22C805.89 494.31 806.51 492.15 807.03 490.3V490.22H807.1L812.84 490.27H814.4H814.8L814.93 490.31Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1380.72 1111.08H187.72C187.322 1111.08 186.94 1110.92 186.659 1110.64C186.378 1110.36 186.22 1109.98 186.22 1109.58C186.22 1109.18 186.378 1108.8 186.659 1108.52C186.94 1108.24 187.322 1108.08 187.72 1108.08H1380.72C1381.12 1108.08 1381.5 1108.24 1381.78 1108.52C1382.06 1108.8 1382.22 1109.18 1382.22 1109.58C1382.22 1109.98 1382.06 1110.36 1381.78 1110.64C1381.5 1110.92 1381.12 1111.08 1380.72 1111.08Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(38, 150, 190)"
    }
  }), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1380.72 1111.08H187.72C187.322 1111.08 186.94 1110.92 186.659 1110.64C186.378 1110.36 186.22 1109.98 186.22 1109.58C186.22 1109.18 186.378 1108.8 186.659 1108.52C186.94 1108.24 187.322 1108.08 187.72 1108.08H1380.72C1381.12 1108.08 1381.5 1108.24 1381.78 1108.52C1382.06 1108.8 1382.22 1109.18 1382.22 1109.58C1382.22 1109.98 1382.06 1110.36 1381.78 1110.64C1381.5 1110.92 1381.12 1111.08 1380.72 1111.08Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorStand);
export default __webpack_public_path__ + "static/media/doctorStand.421fb14965b7664f83177a5dbcd91570.svg";
export { ForwardRef as ReactComponent };